(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6616],{

/***/ 13124:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[handle]",
      function () {
        return __webpack_require__(86221);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GlobalAvatar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68875);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68062);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66535);
/* harmony import */ var _cyber_co_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26292);
/* harmony import */ var _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51499);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41418);








var AvatarFrame = function(param) {
    var children = param.children, size = param.size, tokenId = param.tokenId, animated = param.animated, sx = param.sx;
    return tokenId ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
        sx: {
            position: "relative"
        },
        children: [
            children,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Stack */ .Kqy, {
                sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    width: size,
                    height: size,
                    position: "absolute",
                    top: "51%",
                    left: "49%",
                    transform: "translate(-50%, -50%)",
                    alignItems: "center",
                    justifyContent: "center"
                }, sx),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
                    src: "/assets/avatar-frames/".concat(animated ? "".concat(tokenId, ".gif") : "".concat(tokenId, ".png")),
                    width: "140%",
                    alt: "avatar-frame"
                })
            })
        ]
    }) : children;
};
function BaseAvatar(props) {
    var src = props.src, _size = props.size, size = _size === void 0 ? 30 : _size, _variant = props.variant, variant = _variant === void 0 ? "circular" : _variant, _alt = props.alt, alt = _alt === void 0 ? "" : _alt, _bordered = props.bordered, bordered = _bordered === void 0 ? false : _bordered, _borderWidth = props.borderWidth, borderWidth = _borderWidth === void 0 ? 1 : _borderWidth, _hexgonBorderColor = props.hexgonBorderColor, hexgonBorderColor = _hexgonBorderColor === void 0 ? "#fff" : _hexgonBorderColor;
    var convert2Number = function(value) {
        if (isString(value)) return parseInt(value, 10);
        return value;
    };
    var safeParam = function(value) {
        if (isString(value)) return value;
        return "".concat(value.toString(), "px");
    };
    var isString = function(value) {
        return Object.prototype.toString.call(value) === "[object String]";
    };
    var _borderWidth1 = safeParam(borderWidth);
    var _size1 = safeParam(size);
    // base hexagon shape
    var HexagonShape = (0,_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .styled */ .zop)("div", {
        name: "HexagonShape",
        shouldForwardProp: function(p) {
            return p !== "size";
        }
    })(function(param) {
        var size = param.size;
        return {
            width: size,
            height: size,
            overflow: "hidden",
            boxSizing: "content-box",
            clipPath: "polygon(92.32051% 40%, 93.79385% 43.1596%, 94.69616% 46.52704%, 95% 50%, 94.69616% 53.47296%, 93.79385% 56.8404%, 92.32051% 60%, 79.82051% 81.65064%, 77.82089% 84.50639%, 75.35575% 86.97152%, 72.5% 88.97114%, 69.3404% 90.44449%, 65.97296% 91.34679%, 62.5% 91.65064%, 37.5% 91.65064%, 34.02704% 91.34679%, 30.6596% 90.44449%, 27.5% 88.97114%, 24.64425% 86.97152%, 22.17911% 84.50639%, 20.17949% 81.65064%, 7.67949% 60%, 6.20615% 56.8404%, 5.30384% 53.47296%, 5% 50%, 5.30384% 46.52704%, 6.20615% 43.1596%, 7.67949% 40%, 20.17949% 18.34936%, 22.17911% 15.49361%, 24.64425% 13.02848%, 27.5% 11.02886%, 30.6596% 9.55551%, 34.02704% 8.65321%, 37.5% 8.34936%, 62.5% 8.34936%, 65.97296% 8.65321%, 69.3404% 9.55551%, 72.5% 11.02886%, 75.35575% 13.02848%, 77.82089% 15.49361%, 79.82051% 18.34936%)"
        };
    });
    // make sure avatar is display inside hexagon
    var HexagonAvatarWrapper = (0,_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .styled */ .zop)(HexagonShape, {
        name: "HexagonAvatarWrapper"
    })(function(param) {
        var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
        return {
            background: "#000",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        };
    });
    // background dom element behind the actual avatar comp, the diff between HexagonAvatarBg and HexagonAvatarWrapper is used as border
    var HexagonAvatarBg = (0,_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .styled */ .zop)(HexagonShape, {
        name: "HexagonAvatarBg"
    })(function() {
        return {
            background: hexgonBorderColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        };
    });
    /** ---------------------------- Hexgon Avatar ------------------------------------ */ if (variant === "hexagon") {
        var _hexgonWrapperSx = props.hexgonWrapperSx, hexgonWrapperSx = _hexgonWrapperSx === void 0 ? {} : _hexgonWrapperSx, _hexgonAvatarSx = props.hexgonAvatarSx, hexgonAvatarSx = _hexgonAvatarSx === void 0 ? {} : _hexgonAvatarSx;
        var _innerSize = safeParam(size);
        if (bordered) {
            _innerSize = safeParam(convert2Number(_size1) - convert2Number(borderWidth) * 2);
        }
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(HexagonAvatarBg, {
            size: _size1,
            sx: hexgonWrapperSx,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(HexagonAvatarWrapper, {
                size: _innerSize,
                sx: hexgonAvatarSx,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Avatar */ .qEK, {
                    src: (0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_2__/* .fixIPFSUrl */ .A3)(src),
                    sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        width: _innerSize,
                        height: _innerSize
                    }, props.sx)
                })
            })
        });
    }
    /** ---------------------------- Circular Avatar ------------------------------------ */ var _sx = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        width: _size1,
        height: _size1,
        border: bordered ? "".concat(_borderWidth1, " solid") : "none",
        borderColor: "bg.0",
        borderRadius: variant === "square" ? 1 : "50%"
    }, props.sx);
    var _attrs = {
        src: src,
        alt: alt,
        sx: _sx,
        variant: variant
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Avatar */ .qEK, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _attrs));
}
function GlobalAvatar(props) {
    var src = props.src, _loading = props.loading, loading = _loading === void 0 ? false : _loading, _size = props.size, size = _size === void 0 ? 30 : _size, _type = props.type, type = _type === void 0 ? _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .ProfileType.Personal */ .pqZ.Personal : _type, _sx = props.sx, sx = _sx === void 0 ? {} : _sx, _alt = props.alt, alt = _alt === void 0 ? "" : _alt, _bordered = props.bordered, bordered = _bordered === void 0 ? false : _bordered, _borderWidth = props.borderWidth, borderWidth = _borderWidth === void 0 ? 4 : _borderWidth, _theme = props.theme, theme = _theme === void 0 ? "light" : _theme, _variant = props.variant, variant = _variant === void 0 ? "circular" : _variant, _hexgonAvatarSx = props.hexgonAvatarSx, hexgonAvatarSx = _hexgonAvatarSx === void 0 ? {} : _hexgonAvatarSx, _hexgonWrapperSx = props.hexgonWrapperSx, hexgonWrapperSx = _hexgonWrapperSx === void 0 ? {} : _hexgonWrapperSx, _hexgonBorderColor = props.hexgonBorderColor, hexgonBorderColor = _hexgonBorderColor === void 0 ? "#fff" : _hexgonBorderColor, address = props.address, frame = props.frame, onClick = props.onClick;
    var eoa = (0,_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useAddresses */ .Jz)().eoa;
    var composeUrl = function(url) {
        if (url === null) {
            return "";
        }
        if (!url) {
            return (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateUrl */ .nu)(address || eoa, type);
        }
        if (url.startsWith("blob:")) return url;
        return (0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_2__/* .fixNFTIPFSURL */ .Ff)(url);
    };
    var convert2Number = function(value) {
        if (isString(value)) return parseInt(value, 10);
        return value;
    };
    var isString = function(value) {
        return Object.prototype.toString.call(value) === "[object String]";
    };
    return loading ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .CircularProgress */ .D8x, {
        size: convert2Number(size) / 2,
        sx: {
            color: theme === "light" ? "#000" : "#fff"
        }
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
        onClick: onClick ? onClick : function() {
            return null;
        },
        className: "global-avatar-with-frame",
        sx: {
            cursor: onClick ? "pointer" : "auto"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(AvatarFrame, {
            size: (frame === null || frame === void 0 ? void 0 : frame.size) || size,
            tokenId: frame === null || frame === void 0 ? void 0 : frame.tokenId,
            animated: frame === null || frame === void 0 ? void 0 : frame.animated,
            sx: {
                cursor: onClick ? "pointer" : "auto"
            },
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(BaseAvatar, {
                src: composeUrl(src),
                size: size,
                sx: sx,
                alt: alt,
                bordered: bordered,
                borderWidth: borderWidth,
                variant: type === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .ProfileType.Organization */ .pqZ.Organization ? "square" : variant,
                hexgonAvatarSx: hexgonAvatarSx,
                hexgonWrapperSx: hexgonWrapperSx,
                hexgonBorderColor: hexgonBorderColor
            })
        })
    });
};


/***/ }),

/***/ 88099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Headline; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../packages/utils/index.ts + 27 modules
var utils = __webpack_require__(26292);
// EXTERNAL MODULE: ../../packages/cyberlab-uikit/src/index.ts + 192 modules
var src = __webpack_require__(41418);
// EXTERNAL MODULE: ../../packages/pwa-icons/index.ts + 1 modules
var pwa_icons = __webpack_require__(78221);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Profile/EAS/OrgMemberVerify/CreateAndVerifyButton.tsx




function CreateAndVerifyButton(param) {
    var _hasHeadline = param.hasHeadline, hasHeadline = _hasHeadline === void 0 ? false : _hasHeadline, profileId = param.profileId;
    if (hasHeadline) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/".concat(profileId, "/add-title"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kCb, {
            gap: 0.5,
            px: 1,
            py: 0.5,
            border: "1px dashed",
            borderColor: "secondary",
            borderRadius: 1,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                    name: "icon-add-circle-line",
                    size: 18
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                    variant: "caption",
                    bold: true,
                    color: "primary",
                    children: "Create and verify your title"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Headline.tsx






function Headline(param) {
    var data = param.data, isVerified = param.isVerified, couldClaim = param.couldClaim, verifyIcon = param.verifyIcon, profileId = param.profileId, _showVerify = param.showVerify, showVerify = _showVerify === void 0 ? false : _showVerify;
    var push = (0,router.useRouter)().push;
    var handleGo2CompanyPage = function() {
        if (data === null || data === void 0 ? void 0 : data.profileId) {
            push("/".concat(data.profileId));
        } else if (data === null || data === void 0 ? void 0 : data.twitterId) {
            window.open((0,utils/* fixTwitterLink */.YO)({
                id: data.twitterId
            }));
        } else {
            return;
        }
    };
    var showBadge = isVerified || couldClaim;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kCb, {
        alignItems: "center",
        gap: 0.5,
        flexWrap: "wrap",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                variant: "body2",
                color: "text.250",
                onClick: handleGo2CompanyPage,
                noWrap: true,
                children: data === null || data === void 0 ? void 0 : data.title
            }),
            (data === null || data === void 0 ? void 0 : data.displayName) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xvT, {
                variant: "body2",
                color: "text.100",
                children: [
                    "@",
                    data === null || data === void 0 ? void 0 : data.displayName
                ]
            }) : null,
            showBadge ? verifyIcon !== null && verifyIcon !== void 0 ? verifyIcon : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
                name: "icon-Verified-person-fill",
                size: 18,
                color: "brand.main"
            }) : showVerify ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateAndVerifyButton, {
                hasHeadline: !!(data === null || data === void 0 ? void 0 : data.title),
                profileId: profileId
            }) : null
        ]
    });
}
/* harmony default export */ var components_Headline = (Headline);


/***/ }),

/***/ 98944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CopyIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66383);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52903);
/* harmony import */ var _cyber_co_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26292);
/* harmony import */ var _link3_pwa_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78221);




function CopyIcon(props) {
    var _size = props.size, size = _size === void 0 ? 18 : _size, text = props.text;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_0__/* .useCopyToClipboard */ .m9)(), 2), isCopied = ref[0], copy = ref[1];
    var handleCopy = function() {
        copy(text);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_link3_pwa_icons__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .J, {
        name: isCopied ? "icon-file-copy-success-line" : "icon-file-copy-line",
        color: isCopied ? "success.main" : "text.100",
        size: size,
        onClick: handleCopy
    });
};


/***/ }),

/***/ 60863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OrgRow; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);
/* harmony import */ var _GlobalAvatar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64064);
/* harmony import */ var _Icons_OrgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7558);
/* harmony import */ var _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51499);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






function OrgRow(param) {
    var gap = param.gap, orgAvatar = param.orgAvatar, orgName = param.orgName, avatarSize = param.avatarSize, textColor = param.textColor, handle = param.handle;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Flex */ .kCb, {
        gap: gap || 0.5,
        alignItems: "center",
        onClick: function(e) {
            if (!handle) return;
            e.stopPropagation();
            router.push("/".concat(handle));
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_GlobalAvatar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                src: orgAvatar,
                variant: "square",
                type: _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .ProfileType.Organization */ .pqZ.Organization,
                size: avatarSize || 24,
                sx: {
                    borderRadius: 1
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xvT, {
                variant: "body2",
                color: textColor || "text.250",
                children: orgName
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_Icons_OrgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                size: 18
            })
        ]
    });
};


/***/ }),

/***/ 40231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PostCard; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);
/* harmony import */ var _utils_getAuthorFromProfile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88834);
/* harmony import */ var _cyber_co_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26292);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41418);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62650);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _OrgRow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60863);
/* harmony import */ var _Wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2390);








function PostCard(props) {
    var data = props.data, sx = props.sx;
    var cover = data.cover, title = data.title, description = data.description, publishedAt = data.publishedAt, profile = data.profile, readTime = data.readTime, essence = data.essence, id = data.id;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_Wrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        gap: 1.5,
        onClick: function() {
            router.push("/post/".concat(id));
        },
        sx: sx,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                gap: 1,
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_OrgRow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        orgAvatar: (0,_utils_getAuthorFromProfile__WEBPACK_IMPORTED_MODULE_0__/* .getAuthorFromProfile */ .b)(profile).picture || "",
                        orgName: (0,_utils_getAuthorFromProfile__WEBPACK_IMPORTED_MODULE_0__/* .getAuthorFromProfile */ .b)(profile).displayName,
                        textColor: "text.100",
                        handle: (0,_utils_getAuthorFromProfile__WEBPACK_IMPORTED_MODULE_0__/* .getAuthorFromProfile */ .b)(profile).handle
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                        variant: "caption",
                        color: "text.250",
                        children: (0,date_fns_format__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(new Date(publishedAt), "MMM dd, yyyy")
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                variant: "subtitle1",
                bold: true,
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                variant: "body2",
                lines: 3,
                children: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("img", {
                src: cover,
                alt: "",
                style: {
                    width: "100%",
                    display: "block",
                    borderRadius: 4
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                        variant: "caption",
                        color: "text.250",
                        children: [
                            readTime,
                            " min read"
                        ]
                    }),
                    (essence === null || essence === void 0 ? void 0 : essence.totalSupply) && (essence === null || essence === void 0 ? void 0 : essence.totalCollected) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                bold: true,
                                variant: "caption",
                                children: (0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(essence === null || essence === void 0 ? void 0 : essence.totalCollected)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                variant: "caption",
                                color: "text.250",
                                children: [
                                    (essence === null || essence === void 0 ? void 0 : essence.totalSupply) >= 1000000 ? null : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                                        children: [
                                            "/",
                                            (0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(essence === null || essence === void 0 ? void 0 : essence.totalSupply),
                                            " "
                                        ]
                                    }),
                                    "Collected"
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};


/***/ }),

/***/ 21713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52903);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);


function CredItem(param) {
    var name = param.name, index = param.index, _isActive = param.isActive, isActive = _isActive === void 0 ? true : _isActive, onClick = param.onClick;
    var palette = (0,_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .useTheme */ .FgM)().palette;
    var colorMap = [
        palette.brand.main,
        palette.twitter,
        palette.warning.main,
        palette.error.main,
        palette.success.main,
        "#9858FF", 
    ];
    var primaryColor = colorMap[index % colorMap.length];
    var secondaryColor = (0,_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .alpha */ .Fqy)(colorMap[index % colorMap.length], 0.1);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xvT, {
        onClick: onClick,
        variant: "caption",
        bold: true,
        sx: {
            border: "1px solid",
            borderColor: primaryColor,
            backgroundColor: secondaryColor,
            color: primaryColor,
            borderRadius: 1,
            px: 1.5,
            py: 0.5,
            opacity: isActive ? 1 : 0.5,
            transition: "opacity 0.3s"
        },
        children: name
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CredItem);


/***/ }),

/***/ 31623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);
/* harmony import */ var _core_NFTItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19618);



var SelectedCover = function(props) {
    var isSelected = props.isSelected, sequence = props.sequence;
    if (!isSelected) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xuv, {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 2,
        bgcolor: "rgba(0,0,0,0.5)",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xvT, {
                color: "text.100",
                variant: "caption",
                bold: true,
                position: "absolute",
                top: 4,
                left: 4,
                children: sequence
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Radio */ .Y8K, {
                checked: isSelected,
                position: "absolute",
                top: 4,
                right: 4
            })
        ]
    });
};
function SelectableNFTItem(props) {
    var imageUrl = props.imageUrl, name = props.name, onSelect = props.onSelect, isSelected = props.isSelected, sequence = props.sequence;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Stack */ .Kqy, {
        gap: 1.5,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xuv, {
                position: "relative",
                onClick: onSelect,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_core_NFTItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        imageUrl: imageUrl
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(SelectedCover, {
                        sequence: sequence,
                        isSelected: isSelected
                    })
                ]
            }),
            name ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xvT, {
                variant: "body2",
                bold: true,
                color: "text.100",
                children: name
            }) : null
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SelectableNFTItem);


/***/ }),

/***/ 60327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Recommendation_RecommendationList; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../packages/cyberlab-uikit/src/index.ts + 192 modules
var src = __webpack_require__(41418);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/Profile/blocks/core/ShowMore.tsx
var ShowMore = __webpack_require__(81330);
// EXTERNAL MODULE: ./src/components/Headline.tsx + 1 modules
var Headline = __webpack_require__(88099);
// EXTERNAL MODULE: ./src/components/User/index.tsx
var User = __webpack_require__(44630);
// EXTERNAL MODULE: ../../packages/service/pwa/generated/graphql.ts
var graphql = __webpack_require__(51499);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Recommendation/RecommendationItem.tsx





function RecommendationItem(props) {
    var ref;
    var data = props.data, renderIcon = props.renderIcon;
    var profile = data.user.profile;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
        gap: 1,
        sx: {
            opacity: (data === null || data === void 0 ? void 0 : data.hidden) ? 0.5 : 1
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Box */.xuv, {
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(User/* default */.Z, {
                        profileHandle: data.user.lightInfo.handle,
                        profileId: profile.id,
                        wrapperProps: {
                            gap: 1.5,
                            width: "100%"
                        },
                        avatar: data.user.lightInfo.avatar,
                        displayName: data.user.lightInfo.displayName,
                        type: graphql/* ProfileType.Personal */.pqZ.Personal,
                        desc: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Headline/* default */.Z, {
                            data: profile.headline,
                            isVerified: !!((ref = data.user.lightInfo.attestation) === null || ref === void 0 ? void 0 : ref.uid)
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Box */.xuv, {
                        position: "absolute",
                        top: 0,
                        right: 0,
                        children: renderIcon && renderIcon(data)
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
                pl: "52px",
                variant: "body2",
                color: "text.100",
                children: data.content
            })
        ]
    });
}
/* harmony default export */ var Recommendation_RecommendationItem = (RecommendationItem);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Recommendation/RecommendationList.tsx





function RecommendationList(props) {
    var _data = props.data, data = _data === void 0 ? [] : _data, renderIcon = props.renderIcon;
    var hasMore = data.length > 3;
    var ref = (0,react.useState)(false), showMore = ref[0], toggleShowMore = ref[1];
    if (data.length < 1) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xvT, {
            textAlign: "center",
            color: "text.250",
            my: 5,
            mb: 2,
            children: "No Recommendations"
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            data.slice(0, showMore ? data.length : 4).map(function(rec) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Recommendation_RecommendationItem, {
                    data: rec,
                    renderIcon: renderIcon
                }, rec.user.id);
            }),
            hasMore ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMore/* default */.Z, {
                wrapperProps: {
                    my: 0
                },
                isShowMore: showMore,
                setShowMore: function() {
                    return toggleShowMore(function(state) {
                        return !state;
                    });
                }
            }) : null
        ]
    });
}
/* harmony default export */ var Recommendation_RecommendationList = (RecommendationList);


/***/ }),

/***/ 2304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52903);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);


var SkillTag = function(props) {
    var data = props.data, onClick = props.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Flex */ .kCb, {
        alignItems: "center",
        width: "fit-content",
        gap: 1,
        px: 1.5,
        border: "1px solid",
        borderColor: "text.100",
        borderRadius: 1,
        height: 28,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xvT, {
                variant: "body2",
                color: "text.100",
                children: data.name
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Divider */ .izJ, {
                sx: {
                    height: 16,
                    mt: "5px"
                },
                flexItem: true,
                orientation: "vertical"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xvT, {
                variant: "body2",
                color: "text.250",
                children: data.endorserCount
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkillTag);


/***/ }),

/***/ 56163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52903);
/* harmony import */ var _component_GlobalAvatar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64064);
/* harmony import */ var _component_Icons_OrgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7558);
/* harmony import */ var _cyber_co_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26292);
/* harmony import */ var _cyber_service_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58884);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);
/* harmony import */ var _core_NFTItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19618);












var StyledTooltip = (0,_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .styled */ .zop)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Tooltip */ .ua7, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        classes: {
            popper: className
        }
    }));
})((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, "& .".concat(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .tooltipClasses.tooltip */ .ikj.tooltip), {
    margin: 0,
    padding: 12
}));
function W3stItem(props) {
    var tokenUri = props.tokenUri, _noTip = props.noTip, noTip = _noTip === void 0 ? false : _noTip;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), open = ref[0], setOpen = ref[1];
    // const [metaData, setMetaData] = useState<TW3stMetaData>();
    var ref1 = (0,_cyber_service_api__WEBPACK_IMPORTED_MODULE_3__/* .useRetriveW3stInfoQuery */ .tq)(tokenUri), metaData = ref1.data, isFetching = ref1.isFetching;
    if (isFetching) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .RatioBox */ .Zeg, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Skeleton */ .OdW, {
            variant: "rounded",
            width: "100%",
            height: "100%"
        })
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .ClickAwayListener */ .dyZ, {
        onClickAway: function() {
            setOpen(false);
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(StyledTooltip, {
                open: open && !noTip,
                title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Stack */ .Kqy, {
                    gap: 1.5,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xvT, {
                            bold: true,
                            children: metaData === null || metaData === void 0 ? void 0 : metaData.name
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xvT, {
                            variant: "body2",
                            color: "text.250",
                            children: metaData === null || metaData === void 0 ? void 0 : metaData.name
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kCb, {
                            alignItems: "center",
                            gap: 0.5,
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_component_GlobalAvatar__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                                    src: metaData === null || metaData === void 0 ? void 0 : metaData.issuer.avatar,
                                    variant: "square",
                                    size: 18
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xvT, {
                                    variant: "body2",
                                    color: "text.250",
                                    children: metaData === null || metaData === void 0 ? void 0 : metaData.issuer.displayName
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_component_Icons_OrgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    size: 18
                                })
                            ]
                        })
                    ]
                }),
                placement: "top",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xuv, {
                    onClick: function() {
                        setOpen(!open);
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_core_NFTItem__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        imageUrl: (0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_2__/* .fixIPFSUrl */ .A3)(metaData === null || metaData === void 0 ? void 0 : metaData.image)
                    })
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (W3stItem);


/***/ }),

/***/ 9749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DeleteSectionButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);
/* harmony import */ var _link3_pwa_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78221);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);







function DeleteSectionButton(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], toggleIsOpen = ref[1];
    var onDelete = props.onDelete, _title = props.title, title = _title === void 0 ? "Delete this Section" : _title, _desc = props.desc, desc = _desc === void 0 ? "Are you sure you want to delete this section?" : _desc, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "onDelete",
        "title",
        "desc"
    ]);
    var openConfirmModal = function() {
        toggleIsOpen(true);
    };
    var closeConfirmModal = function() {
        toggleIsOpen(false);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .LoadingButton */ .flC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                startIcon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_link3_pwa_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    name: "icon-delete-bin-line",
                    color: "error.main",
                    size: 24
                }),
                sx: {
                    bgcolor: "bg.0",
                    mt: 1,
                    borderRadius: 0,
                    height: 48,
                    flexShrink: 0
                },
                color: "error"
            }, buttonProps), {
                onClick: openConfirmModal,
                children: buttonProps.children
            })),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .ConfirmModal */ .sm4, {
                onConfirm: onDelete,
                title: title,
                open: isOpen,
                onClose: closeConfirmModal,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xvT, {
                    variant: "body2",
                    color: "text.250",
                    children: desc
                })
            })
        ]
    });
};


/***/ }),

/***/ 52012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IG": function() { return /* binding */ AddIconButton; },
/* harmony export */   "dY": function() { return /* binding */ EditIcon; }
/* harmony export */ });
/* unused harmony export EditIconButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52903);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);
/* harmony import */ var _link3_pwa_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78221);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);






var EditIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Stack */ .Kqy, {
        onClick: function(e) {
            if (props.onClick) {
                e.stopPropagation();
                e.preventDefault();
                props.onClick();
            }
        },
        sx: function(param) {
            var palette = param.palette;
            return {
                backdropFilter: "blur(5px)",
                bgcolor: palette.mode === "light" ? "rgba(255, 255, 255, 0.50)" : "rgba(0, 0, 0, 0.50)"
            };
        },
        borderRadius: 1,
        border: "1px solid #fff",
        p: "2px",
        position: "absolute",
        top: 12,
        right: 12,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_link3_pwa_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            name: "icon-edit-line",
            size: 18,
            alignItems: "center",
            justifyContent: "center"
        })
    });
};
function EditIconButton(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .zxk, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        size: "small",
        // variant='outlined'
        color: "primary",
        sx: {
            height: 28,
            width: 28
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_link3_pwa_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            name: "icon-edit-line"
        })
    }));
}
function AddIconButton(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .zxk, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        size: "small",
        variant: "outlined",
        color: "primary",
        sx: {
            height: 28,
            px: 1,
            flexShrink: 0
        },
        startIcon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_link3_pwa_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            size: 18,
            name: "icon-add-circle-line",
            mb: 0.25
        }),
        children: "Add"
    }));
}
function EditButton(props) {
    var _hidden = props.hidden, hidden = _hidden === void 0 ? true : _hidden, data = props.data, profileId = props.profileId, isCreate = props.isCreate, Modal = props.Modal, isModalOpenFromProps = props.isModalOpen, openModalFromProps = props.openModal, closeModalFromProps = props.closeModal;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isModalOpen = ref[0], toggleIsModal = ref[1];
    var openModal = function() {
        if (openModalFromProps) {
            openModalFromProps();
        } else {
            toggleIsModal(true);
        }
    };
    var closeModal = function() {
        if (closeModalFromProps) {
            closeModalFromProps();
        } else {
            toggleIsModal(false);
        }
    };
    if (hidden) return null;
    var Button = isCreate ? AddIconButton : EditIconButton;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Button, {
                onClick: openModal
            }),
            Modal ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Modal, {
                onClose: closeModal,
                open: isModalOpenFromProps || isModalOpen,
                blockData: data,
                profileId: profileId
            }) : null
        ]
    });
}
/* harmony default export */ __webpack_exports__["ZP"] = (EditButton);


/***/ }),

/***/ 12406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NFTGrid; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52903);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _ShowMore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81330);






function NFTGrid(param) {
    var _itemLength = param.itemLength, itemLength = _itemLength === void 0 ? 0 : _itemLength, children = param.children, wrapperProps = param.wrapperProps;
    var contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowMore = ref[0], setIsShowMore = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), contentHeight = ref1[0], setContentHeight = ref1[1];
    var needShowMore = itemLength && itemLength > 6;
    var columnCount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!itemLength) return "1";
        switch(itemLength){
            case 1:
                return "1";
            case 2:
            case 4:
                return "2";
            default:
                return "3";
        }
    }, [
        itemLength
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (contentRef.current) {
            var rowCount = Math.ceil(itemLength / Number(columnCount));
            // 两行的高度
            setContentHeight(contentRef.current.clientHeight / rowCount * Math.min(2, rowCount));
        }
    }, [
        itemLength
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Stack */ .Kqy, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapperProps), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Collapse */ .UO1, {
                in: isShowMore || !needShowMore,
                collapsedSize: contentHeight,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xuv, {
                    sx: {
                        display: "grid",
                        gap: 3,
                        gridTemplateColumns: "repeat(".concat(columnCount, ", 1fr)")
                    },
                    ref: contentRef,
                    children: children
                })
            }),
            needShowMore ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_ShowMore__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                isShowMore: isShowMore,
                setShowMore: function() {
                    setIsShowMore(!isShowMore);
                }
            }) : null
        ]
    }));
};


/***/ }),

/***/ 19618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52903);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);


var NftNameCover = function(param) {
    var name = param.name;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Stack */ .Kqy, {
        alignItems: "center",
        justifyContent: "center",
        className: "nft-name",
        display: "none",
        position: "absolute",
        width: "100%",
        height: "100%",
        sx: function(param) {
            var palette = param.palette;
            return {
                bgcolor: palette.mode === "dark" ? "rgba(0,0,0,0.5)" : "rgba(255,255,255,0.5)",
                border: "1px solid",
                borderColor: "border.100",
                borderRadius: 1,
                backdropFilter: "blur(5px)"
            };
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xvT, {
            mx: 1.5,
            variant: "body2",
            bold: true,
            color: "text.100",
            children: name
        })
    });
};
function NFTItem(param) {
    var name = param.name, imageUrl = param.imageUrl;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Stack */ .Kqy, {
        gap: 1.5,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .RatioBox */ .Zeg, {
            sx: {
                borderRadius: 1,
                overflow: "hidden",
                "&:hover": {
                    ".nft-name": {
                        display: "flex"
                    }
                }
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .StyledImage */ .Yoh, {
                    src: imageUrl,
                    sx: {
                        width: "100%",
                        height: "100%",
                        left: 0,
                        top: 0,
                        position: "absolute",
                        objectFit: "cover"
                    }
                }),
                name ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(NftNameCover, {
                    name: name
                }) : null
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NFTItem);


/***/ }),

/***/ 94927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProfileForm_drawer; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ./src/hooks/profile/index.ts + 5 modules
var profile = __webpack_require__(7451);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/utils/index.ts + 2 modules
var utils = __webpack_require__(66535);
// EXTERNAL MODULE: ../../packages/utils/index.ts + 27 modules
var packages_utils = __webpack_require__(26292);
// EXTERNAL MODULE: ../../packages/service/pwa/generated/graphql.ts
var graphql = __webpack_require__(51499);
// EXTERNAL MODULE: ../../packages/cyberlab-uikit/src/index.ts + 192 modules
var src = __webpack_require__(41418);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
;// CONCATENATED MODULE: ./src/hooks/profile/useCreateRecommendation.ts













var _obj;
var ERROR_MSG = (_obj = {}, (0,_define_property/* default */.Z)(_obj, graphql/* GiveRecommendationResponse_Status.AlreadyRecommended */.yaz.AlreadyRecommended, "AlreadyRecommended"), (0,_define_property/* default */.Z)(_obj, graphql/* GiveRecommendationResponse_Status.InvalidContent */.yaz.InvalidContent, "InvalidContent"), (0,_define_property/* default */.Z)(_obj, graphql/* GiveRecommendationResponse_Status.NotLogin */.yaz.NotLogin, "NotLogin"), (0,_define_property/* default */.Z)(_obj, graphql/* GiveRecommendationResponse_Status.PermissionDenied */.yaz.PermissionDenied, "PermissionDenied"), (0,_define_property/* default */.Z)(_obj, graphql/* GiveRecommendationResponse_Status.UnconnectedProfile */.yaz.UnconnectedProfile, "You need to establish a connection with this person before writing a recommendation!"), (0,_define_property/* default */.Z)(_obj, graphql/* GiveRecommendationResponse_Status.ProfileNotFound */.yaz.ProfileNotFound, "ProfileNotFound"), _obj);
var useCreateRecommendation = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGiveRecommendationMutation */._sv)(), 2), creator = ref[0], createResult = ref[1];
    var createRecommendation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", creator({
                            input: input
                        }).then(function(data) {
                            if ("data" in data && data.data.giveRecommendation.status === graphql/* GiveRecommendationResponse_Status.Success */.yaz.Success) {
                                return {
                                    isSuccess: true,
                                    message: ERROR_MSG[data.data.giveRecommendation.status]
                                };
                            }
                            return {
                                isSuccess: false,
                                message: "data" in data ? ERROR_MSG[data.data.giveRecommendation.status] : "Something went wrong!"
                            };
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createRecommendation(input) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_param) {
            var profileId, handle, input, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        profileId = _param.profileId, handle = _param.handle, input = (0,_object_without_properties/* default */.Z)(_param, [
                            "profileId",
                            "handle"
                        ]);
                        _ctx.next = 3;
                        return createRecommendation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                            profileId: profileId
                        }));
                    case 3:
                        res = _ctx.sent;
                        if (!res.isSuccess) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 7;
                        return dispatch(graphql/* api.endpoints.getProfile.initiate */.hi0.endpoints.getProfile.initiate((0,packages_utils/* getProfileQueryParams */.Vy)(handle), {
                            forceRefetch: true
                        }));
                    case 7:
                        src/* toast.success */.Amu.success("Give Recommendation Successfully!");
                        (0,utils/* revalidateSSGPage */.eb)(handle);
                        _ctx.next = 12;
                        break;
                    case 11:
                        {
                            src/* toast.error */.Amu.error(res.message);
                        }
                    case 12:
                        return _ctx.abrupt("return", res);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }(), [
        creator
    ]);
    return [
        handleUpdate,
        createResult
    ];
};

// EXTERNAL MODULE: ./src/hooks/profile/useEnhancedUpdateOrgProfile.tsx
var useEnhancedUpdateOrgProfile = __webpack_require__(99165);
;// CONCATENATED MODULE: ./src/hooks/profile/useUpdateEducation.ts











var useUpdateEducation = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUpdateEducationMutation */.Kn9)(), 2), updater = ref[0], updateResult = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCreateEducationMutation */.OQQ)(), 2), creator = ref1[0], createResult = ref1[1];
    var updateEducation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", updater({
                            input: input
                        }).then(function(data) {
                            if ("data" in data && data.data.updateEducation.status === graphql/* UpdateEducationResponse_Status.Success */.KkZ.Success) {
                                return {
                                    isSuccess: true
                                };
                            }
                            return {
                                isSuccess: false
                            };
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateEducation(input) {
            return _ref.apply(this, arguments);
        };
    }();
    var createEducation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", creator({
                            input: input
                        }).then(function(data) {
                            if ("data" in data && data.data.createEducation.status === graphql/* CreateEducationResponse_Status.Success */.T4I.Success) {
                                return {
                                    isSuccess: true
                                };
                            }
                            return {
                                isSuccess: false
                            };
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createEducation(input) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_param) {
            var profileId, educationId, handle, input, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        profileId = _param.profileId, educationId = _param.educationId, handle = _param.handle, input = (0,_object_without_properties/* default */.Z)(_param, [
                            "profileId",
                            "educationId",
                            "handle"
                        ]);
                        _ctx.next = 3;
                        return educationId ? updateEducation((0,_object_spread/* default */.Z)({
                            educationId: educationId
                        }, input)) : createEducation((0,_object_spread/* default */.Z)({
                            profileId: profileId
                        }, input));
                    case 3:
                        res = _ctx.sent;
                        if (!res.isSuccess) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 7;
                        return dispatch(graphql/* api.endpoints.getProfile.initiate */.hi0.endpoints.getProfile.initiate((0,packages_utils/* getProfileQueryParams */.Vy)(handle), {
                            forceRefetch: true
                        }));
                    case 7:
                        src/* toast.success */.Amu.success("Update Successfully!");
                        (0,utils/* revalidateSSGPage */.eb)(handle);
                    case 9:
                        return _ctx.abrupt("return", res);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }(), [
        updater
    ]);
    return [
        handleUpdate,
        updateResult || createResult
    ];
};

;// CONCATENATED MODULE: ./src/hooks/profile/useUpdateWorkExp.ts











var useUpdateWorkExp = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUpdateWorkExperienceMutation */.tCM)(), 2), updater = ref[0], updateResult = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCreateWorkExperienceMutation */.Z51)(), 2), creator = ref1[0], createResult = ref1[1];
    var updateEducation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", updater({
                            input: input
                        }).then(function(data) {
                            if ("data" in data && data.data.updateWorkExperience.status === graphql/* UpdateWorkExperienceResponse_Status.Success */.N3J.Success) {
                                return {
                                    isSuccess: true
                                };
                            }
                            return {
                                isSuccess: false
                            };
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateEducation(input) {
            return _ref.apply(this, arguments);
        };
    }();
    var createEducation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", creator({
                            input: input
                        }).then(function(data) {
                            if ("data" in data && data.data.createWorkExperience.status === graphql/* CreateWorkExperienceResponse_Status.Success */.BtH.Success) {
                                return {
                                    isSuccess: true
                                };
                            }
                            return {
                                isSuccess: false
                            };
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createEducation(input) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_param) {
            var profileId, workExperienceId, handle, input, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        profileId = _param.profileId, workExperienceId = _param.workExperienceId, handle = _param.handle, input = (0,_object_without_properties/* default */.Z)(_param, [
                            "profileId",
                            "workExperienceId",
                            "handle"
                        ]);
                        _ctx.next = 3;
                        return workExperienceId ? updateEducation((0,_object_spread/* default */.Z)({
                            workExperienceId: workExperienceId
                        }, input)) : createEducation((0,_object_spread/* default */.Z)({
                            profileId: profileId
                        }, input));
                    case 3:
                        res = _ctx.sent;
                        if (!res.isSuccess) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 7;
                        return dispatch(graphql/* api.endpoints.getProfile.initiate */.hi0.endpoints.getProfile.initiate((0,packages_utils/* getProfileQueryParams */.Vy)(handle), {
                            forceRefetch: true
                        }));
                    case 7:
                        src/* toast.success */.Amu.success("Update Successfully!");
                        (0,utils/* revalidateSSGPage */.eb)(handle);
                    case 9:
                        return _ctx.abrupt("return", res);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }(), [
        updater
    ]);
    return [
        handleUpdate,
        updateResult || createResult
    ];
};

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/getUnixTime/index.js + 1 modules
var getUnixTime = __webpack_require__(17381);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(82276);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/components/Profile/blocks/core/DeleteSectionButton.tsx
var DeleteSectionButton = __webpack_require__(9749);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/core/ProfileForm.drawer.tsx



















function ProfileFormDrawer(props) {
    var open = props.open, title = props.title, children = props.children, blockData = props.blockData, profileId = props.profileId, deleteButtonProps = props.deleteButtonProps, _type = props.type, type = _type === void 0 ? "block" : _type, saveButtonProps = props.saveButtonProps, noDeleteButton = props.noDeleteButton;
    var onClose = props.onClose;
    var query = (0,router.useRouter)().query;
    var handle = ((query === null || query === void 0 ? void 0 : query.handle) || "").toString();
    var ref = (0,index_esm/* useFormContext */.Gc)(), handleSubmit = ref.handleSubmit, reset = ref.reset, formState = ref.formState;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,profile/* useCreateBlocks */.ad)(), 1), create = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,profile/* useUpdateBlocks */.GP)(), 1), update = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,profile/* useDeleteBlocks */.Io)(), 1), deleteCaller = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,profile/* useEnhancedUpdatePersonal */.UY)(), 1), updatePersonalBasicInfo = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useEnhancedUpdateOrgProfile/* useEnhancedUpdateOrgProfile */.c)(), 1), updateOrgBasicInfo = ref5[0];
    var ref6 = (0,_sliced_to_array/* default */.Z)(useUpdateEducation(), 1), updateEducation = ref6[0];
    var ref7 = (0,_sliced_to_array/* default */.Z)(useUpdateWorkExp(), 1), updateWork = ref7[0];
    var ref8 = (0,_sliced_to_array/* default */.Z)(useCreateRecommendation(), 1), giveRecommendation = ref8[0];
    var showCommonDeleteButton = type === "block" && (blockData === null || blockData === void 0 ? void 0 : blockData.id) && (blockData === null || blockData === void 0 ? void 0 : blockData.type) !== graphql/* BlockType.Superlink */.kHU.Superlink && (blockData === null || blockData === void 0 ? void 0 : blockData.type) !== graphql/* BlockType.Skill */.kHU.Skill && !noDeleteButton;
    var createBlock = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(p) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return create(p);
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createBlock(p) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateBlock = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(p) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return update(p);
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateBlock(p) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteBlock = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (showCommonDeleteButton) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return deleteCaller({
                            id: blockData.id,
                            handle: handle
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteBlock() {
            return _ref.apply(this, arguments);
        };
    }();
    var saveBlock = function(v) {
        if (blockData && blockData.id) return updateBlock({
            id: blockData.id,
            handle: handle,
            input: (0,_object_spread/* default */.Z)({
                displayName: blockData.displayName,
                index: blockData.index
            }, v)
        });
        return createBlock({
            profileId: profileId,
            handle: handle,
            input: (0,_object_spread/* default */.Z)({
                displayName: blockData === null || blockData === void 0 ? void 0 : blockData.displayName
            }, v)
        });
    };
    var submit = function(v) {
        switch(type){
            case "block":
                return saveBlock(v);
            case "perProfile":
                return updatePersonalBasicInfo({
                    id: profileId,
                    handle: handle,
                    input: v
                });
            case "orgProfile":
                return updateOrgBasicInfo({
                    id: profileId,
                    handle: handle,
                    input: v
                });
            case "education":
                var startDate = v.startDate, endDate = v.endDate, orgTwitter = v.orgTwitter, restEduValue = (0,_object_without_properties/* default */.Z)(v, [
                    "startDate",
                    "endDate",
                    "orgTwitter"
                ]);
                return updateEducation((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restEduValue), {
                    startDate: (0,getUnixTime/* default */.Z)(startDate),
                    endDate: endDate ? (0,isSameDay/* default */.Z)(new Date(), endDate) ? undefined : (0,getUnixTime/* default */.Z)(endDate) : undefined,
                    orgAvatar: orgTwitter.avatar,
                    orgName: orgTwitter.displayName,
                    orgTwitterId: orgTwitter.twitterId,
                    orgTwitterHandle: orgTwitter.twitterHandle,
                    handle: handle,
                    profileId: profileId
                }));
            case "workExp":
                var wStartDate = v.startDate, wEndDate = v.endDate, wOrgTwitter = v.orgTwitter, restWorkValue = (0,_object_without_properties/* default */.Z)(v, [
                    "startDate",
                    "endDate",
                    "orgTwitter"
                ]);
                return updateWork((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restWorkValue), {
                    startDate: (0,getUnixTime/* default */.Z)(wStartDate),
                    endDate: wEndDate ? (0,isSameDay/* default */.Z)(new Date(), wEndDate) ? undefined : (0,getUnixTime/* default */.Z)(wEndDate) : undefined,
                    orgAvatar: wOrgTwitter.avatar,
                    orgName: wOrgTwitter.displayName,
                    orgTwitterId: wOrgTwitter.twitterId,
                    orgTwitterHandle: wOrgTwitter.twitterHandle,
                    handle: handle,
                    profileId: profileId
                }));
            case "recommendation":
                var content = v.content;
                return giveRecommendation({
                    handle: handle,
                    profileId: profileId,
                    content: content
                });
            default:
                return saveBlock(v);
        }
    };
    var onSubmit = function() {
        return handleSubmit(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(v) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return submit(v);
                        case 2:
                            res = _ctx.sent;
                            if ((res === null || res === void 0 ? void 0 : res.isSuccess) && onClose) {
                                onClose();
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(v) {
                return _ref.apply(this, arguments);
            };
        }())();
    };
    // logic for reseting form value
    (0,react.useEffect)(function() {
        return function() {
            reset({});
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* FullScreenDrawer */.nss, {
        open: open,
        onClose: onClose,
        title: title,
        buttonProps: (0,_object_spread/* default */.Z)({
            onClick: onSubmit,
            loading: formState.isSubmitting
        }, saveButtonProps),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
                onSubmit: function(e) {
                    e.preventDefault();
                    onSubmit();
                },
                children: children
            }),
            showCommonDeleteButton ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeleteSectionButton/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                fullWidth: true
            }, deleteButtonProps), {
                onDelete: deleteBlock,
                children: (deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.children) || "Delete this Section"
            })) : null
        ]
    });
}
/* harmony default export */ var ProfileForm_drawer = (ProfileFormDrawer);


/***/ }),

/***/ 81330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ShowMore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);
/* harmony import */ var _link3_pwa_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78221);





function ShowMore(param) {
    var isShowMore = param.isShowMore, setShowMore = param.setShowMore, wrapperProps = param.wrapperProps;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Flex */ .kCb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        mt: 3,
        onClick: setShowMore
    }, wrapperProps), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xvT, {
                children: isShowMore ? "Show less" : "Show more"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_link3_pwa_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                name: "icon-arrow-tiny-down",
                sx: {
                    transform: isShowMore ? "rotate(180deg)" : ""
                }
            })
        ]
    }));
};


/***/ }),

/***/ 33670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ formatTime; },
/* harmony export */   "u": function() { return /* binding */ getDifference; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48701);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33553);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81810);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88984);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80659);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12647);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62650);

var getDifference = function(start) {
    var end = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var diffYears = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(end, start);
    if (diffYears) return "".concat(diffYears, " ").concat(diffYears == 1 ? "year" : "years");
    var diffMonths = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(end, start);
    if (diffMonths) return "".concat(diffMonths, " ").concat(diffMonths == 1 ? "month" : "months");
    var diffWeeks = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(end, start);
    if (diffWeeks) return "".concat(diffWeeks, " ").concat(diffWeeks == 1 ? "week" : "weeks");
    var diffDays = (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(end, start);
    if (diffDays) return "".concat(diffDays, " ").concat(diffDays == 1 ? "day" : "days");
    var diffHours = (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(end, start);
    if (diffHours) return "".concat(diffHours, " ").concat(diffHours == 1 ? "hour" : "hours");
    var diffMins = (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(end, start);
    if (diffMins) return "".concat(diffMins, " ").concat(diffMins == 1 ? "min" : "mins");
    return "0 days";
};
var formatTime = function(start, end) {
    return "".concat((0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(start, "MMM yyyy"), " - \n").concat(end ? (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(end, "MMM yyyy") : "Present", " \xb7 ").concat(getDifference(start, end));
};


/***/ }),

/***/ 26164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52903);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87536);




// type TProps = PropsWithChildren<IProfileFormDrawerProps>;
function withForm(Content, formConfig) {
    return function(props) {
        var formMethods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .useForm */ .cI)({
            mode: formConfig === null || formConfig === void 0 ? void 0 : formConfig.mode
        });
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .FormProvider */ .RV, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, formMethods), {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(Content, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props))
        }));
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (withForm);


/***/ }),

/***/ 44630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ User; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);
/* harmony import */ var _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51499);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _GlobalAvatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64064);
/* harmony import */ var _Icons_OrgIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7558);








function User(props) {
    var ref;
    var avatar = props.avatar, displayName = props.displayName, profileId = props.profileId, profileHandle = props.profileHandle, desc = props.desc, wrapperProps = props.wrapperProps, _type = props.type, type = _type === void 0 ? _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .ProfileType.Personal */ .pqZ.Personal : _type;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var data = (0,_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .useGetProfileHandleByIdQuery */ .dNI)({
        id: profileId
    }, {
        skip: !profileId || !!profileHandle
    }).data;
    var _profileHandle = profileHandle || ((ref = data === null || data === void 0 ? void 0 : data.profile.data) === null || ref === void 0 ? void 0 : ref.handle);
    var redirectToUser = function() {
        router.push("/".concat(profileId || _profileHandle));
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
        justifyContent: "space-between",
        alignItems: "center",
        onClick: redirectToUser,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                gap: 1,
                alignItems: "center"
            }, wrapperProps), {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_GlobalAvatar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        size: 40,
                        src: avatar,
                        type: type
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kqy, {
                        gap: 2 / 8,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                        color: "text.100",
                                        bold: true,
                                        variant: "body1",
                                        lines: 1,
                                        children: displayName
                                    }),
                                    type === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_0__/* .ProfileType.Organization */ .pqZ.Organization ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_Icons_OrgIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        size: 18
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                color: "text.250",
                                variant: "caption",
                                children: desc
                            })
                        ]
                    })
                ]
            })),
            typeof desc === "string" && desc.toLowerCase().includes("host") && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_1__/* .Tag */ .Vp9, {
                children: "Hoster"
            })
        ]
    });
};


/***/ }),

/***/ 81208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useUpdateBlockVisibility; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66535);
/* harmony import */ var _cyber_co_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26292);
/* harmony import */ var _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51499);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94449);









var useUpdateBlockVisibility = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .useUpdateBlockVisibilityMutation */ .mHg)(), 2), updateVisibility = ref[0], result = ref[1];
    var handleUpdate = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var id, handle, visibility, res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id, handle = param.handle, visibility = param.visibility;
                        _ctx.next = 3;
                        return updateVisibility({
                            input: {
                                id: id,
                                visibility: visibility
                            }
                        }).then(function(data) {
                            if ("data" in data && data.data.updateBlockVisibility.status === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .UpdateBlockVisibilityResponse_Status.Success */ .hry.Success) {
                                return {
                                    isSuccess: true
                                };
                            }
                            return {
                                isSuccess: false
                            };
                        });
                    case 3:
                        res = _ctx.sent;
                        if (!res.isSuccess) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 7;
                        return dispatch(_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_3__/* .api.endpoints.getProfile.initiate */ .hi0.endpoints.getProfile.initiate((0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_2__/* .getProfileQueryParams */ .Vy)(handle), {
                            forceRefetch: true
                        }));
                    case 7:
                        _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_4__/* .toast.success */ .Amu.success("Update Successfully!");
                        (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .revalidateSSGPage */ .eb)(handle);
                    case 9:
                        return _ctx.abrupt("return", res);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        updateVisibility
    ]);
    return [
        handleUpdate,
        result
    ];
};


/***/ }),

/***/ 86221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);
/* harmony import */ var _component_Layout_PWALayout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83679);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68062);
/* harmony import */ var _views_Profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11979);
/* harmony import */ var _cyber_service_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58884);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94449);







function ProfilePage() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var ref = (0,_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useAddresses */ .Jz)(), eoa = ref.eoa, assetWallets = ref.assetWallets;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (eoa) {
            //prefetch nft data
            dispatch(_cyber_service_api__WEBPACK_IMPORTED_MODULE_3__/* .api.util.prefetch */ .hi.util.prefetch("retriveAllNFTByAddress", assetWallets.join(","), {}));
        }
    }, [
        assetWallets
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_views_Profile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
}
/* harmony default export */ __webpack_exports__["default"] = (ProfilePage);
ProfilePage.getLayout = function getLayout(page) {
    // const profileMetaData = page.props?.profileMetadata;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_component_Layout_PWALayout__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        children: page
    });
}; // export const getStaticProps = ssgProfile;
 // export function getStaticPaths() {
 //   return {
 //     paths: [],
 //     fallback: 'blocking',
 //   };
 // }
 // const getProfileMetaData = (data: any = {}): MetaTagsProps | undefined => {
 //   if (data.type === ProfileType.Personal) {
 //     const perProfile = data as PersonalProfileFragment & PerProfile;
 //     return {
 //       title: `Link3.to | ${perProfile.personalDisplayName.displayName}`,
 //       description: perProfile.bio,
 //       image: getProfileCardLink(
 //         {
 //           displayName: perProfile?.personalDisplayName?.displayName || '',
 //           handle: perProfile?.handle || '',
 //           avatar: fixNFTIPFSURL(perProfile?.personalProfilePicture?.picture),
 //           reputationScore: String(perProfile?.reputation.total || 0),
 //           isVerified: perProfile.isVerified,
 //           title: perProfile.headline.title,
 //           company: perProfile.headline.displayName,
 //         },
 //         true,
 //       ),
 //     };
 //   } else if (data.type === ProfileType.Organization) {
 //     const orgProfile = data as OrgProfile;
 //     return {
 //       title: `Link3.to | ${orgProfile.displayName}`,
 //       description: orgProfile.bio,
 //       image: getProfileCardLink({
 //         displayName: orgProfile?.displayName || '',
 //         handle: orgProfile?.handle,
 //         avatar: fixNFTIPFSURL(orgProfile?.profilePicture),
 //         followerCount: String(orgProfile?.organization?.followersCount || 0),
 //         isVerified: orgProfile?.organization?.verification === VerificationStatus.Verified,
 //         title: orgProfile?.bio || '',
 //       }),
 //     };
 //   }
 //   return undefined;
 // };


/***/ }),

/***/ 91595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ decodeState; },
/* harmony export */   "k": function() { return /* binding */ redirectGetGithubCode; }
/* harmony export */ });
var TWITTER_SCOPES = (/* unused pure expression or super */ null && ([
    "tweet.read",
    "users.read",
    "follows.read",
    "offline.access",
    "like.read"
]));
var redirectGetGithubCode = function() {
    var from = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : location.pathname;
    var redirectUri = window.origin + "/redirect/github";
    var state = "from=".concat(from);
    var authUrl =  true ? "https://github.com/login/oauth/authorize?client_id=Iv1.528aed785c292063&redirect_uri=".concat(redirectUri, "&state=").concat(state) : 0;
    window.location.replace(authUrl);
};
function decodeState(state) {
    if (!state) return "";
    return state.split("=")[1] || "/me/account-setting/social-media";
}


/***/ }),

/***/ 11979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ views_Profile; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/hooks/profile/index.ts + 5 modules
var hooks_profile = __webpack_require__(7451);
// EXTERNAL MODULE: ../../packages/cyberlab-uikit/src/index.ts + 192 modules
var cyberlab_uikit_src = __webpack_require__(41418);
// EXTERNAL MODULE: ../../packages/pwa-icons/index.ts + 1 modules
var pwa_icons = __webpack_require__(78221);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/components/Profile/Header.tsx









var PreviewModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5283).then(__webpack_require__.bind(__webpack_require__, 95283));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95283)
            ];
        }
    },
    ssr: false
});
var ProfileShareModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1805).then(__webpack_require__.bind(__webpack_require__, 11805));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11805)
            ];
        }
    },
    ssr: false
});
var BlockSortModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6139), __webpack_require__.e(8427), __webpack_require__.e(8)]).then(__webpack_require__.bind(__webpack_require__, 90008));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90008)
            ];
        }
    },
    ssr: false
});
var ProfileMenu = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Menu */.v2r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        autoFocus: false,
        isBlur: true,
        needBorder: true
    }, props), {
        onBlur: props.onClose,
        sx: {
            "& .MuiMenu-paper": {
                borderColor: "border.100"
            },
            "& .MuiMenu-list": {
                backgroundColor: "bg.100",
                "& .MuiMenuItem-root": {
                    borderColor: "border.100"
                }
            }
        }
    }));
};
function Header(param) {
    var handle = param.handle;
    var ref = (0,next_router.useRouter)(), back = ref.back, _query = ref.query, handleFromQuery = _query.handle, mode = _query.mode;
    var ref1 = (0,hooks_profile/* useCouldEditProfile */.sc)(), couldEdit = ref1.couldEdit, isPreview = ref1.isPreview;
    var menuAnchorRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), menuOpen = ref2[0], toggleMenuOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isPreivewOpen = ref3[0], toggleIsPreviewOpen = ref3[1];
    var ref4 = (0,react.useState)(false), isShareOpen = ref4[0], toggleIsShareOpen = ref4[1];
    var ref5 = (0,react.useState)(false), isSortSectionOpen = ref5[0], toggleIsSortSectionOpen = ref5[1];
    var openMenu = function() {
        toggleMenuOpen(true);
    };
    var closeMenu = function() {
        toggleMenuOpen(false);
    };
    var openPreview = function() {
        toggleIsPreviewOpen(true);
    };
    var closePreview = function() {
        toggleIsPreviewOpen(false);
    };
    var openShare = function() {
        toggleIsShareOpen(true);
    };
    var closeShare = function() {
        toggleIsShareOpen(false);
    };
    var openSortSection = function() {
        toggleIsSortSectionOpen(true);
    };
    var closeSortSection = function() {
        toggleIsSortSectionOpen(false);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
        bgcolor: "primary.contrastText",
        mb: -60 / 8,
        alignItems: "center",
        width: "100%",
        position: "sticky",
        top: 0,
        py: 1.5,
        px: 2,
        zIndex: 1,
        left: 0,
        sx: function(param) {
            var palette = param.palette;
            return {
                bgcolor: palette.mode === "light" ? "rgba(255,255,255,0.5)" : "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(10px)"
            };
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
                onClick: isPreview ? closePreview : back,
                name: "icon-arrrow-tiny-up",
                size: 36,
                sx: {
                    transform: "rotate(-90deg)"
                },
                color: "#f0f0f0"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                color: "#f0f0f0",
                width: "100%",
                textAlign: "center",
                bold: true,
                variant: "subtitle1",
                children: "Profile"
            }),
            couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Flex */.kCb, {
                        position: "relative",
                        width: 36,
                        height: 36,
                        ref: menuAnchorRef,
                        alignItems: "center",
                        justifyContent: "center",
                        onClick: openMenu,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
                            name: "icon-more-line",
                            size: 24,
                            color: "#f0f0f0"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProfileMenu, {
                        anchorEl: menuAnchorRef.current,
                        onClose: closeMenu,
                        open: menuOpen,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* MenuItem */.sNh, {
                                sx: {
                                    color: "#f0f0f0"
                                },
                                onClick: function() {
                                    openPreview();
                                    closeMenu();
                                },
                                children: "Preview"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* MenuItem */.sNh, {
                                sx: {
                                    color: "#f0f0f0"
                                },
                                onClick: function() {
                                    openSortSection();
                                    closeMenu();
                                },
                                children: "Sort Section"
                            }),
                            handle ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* MenuItem */.sNh, {
                                sx: {
                                    color: "#f0f0f0"
                                },
                                onClick: function() {
                                    openShare();
                                    closeMenu();
                                },
                                children: "Share My Profile"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PreviewModal, {
                        open: isPreivewOpen,
                        onClose: closePreview
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockSortModal, {
                        open: isSortSectionOpen,
                        handleFromQuery: handleFromQuery,
                        onClose: closeSortSection
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Flex */.kCb, {
                width: 36,
                height: 36,
                onClick: openShare,
                position: "relative",
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
                    name: "icon-share-line",
                    size: 24,
                    color: "#f0f0f0"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileShareModal, {
                open: isShareOpen,
                handleFromQuery: handleFromQuery,
                onClose: closeShare
            })
        ]
    });
}
/* harmony default export */ var Profile_Header = (Header);

// EXTERNAL MODULE: ./src/components/Wrapper.tsx
var Wrapper = __webpack_require__(2390);
;// CONCATENATED MODULE: ./src/components/Profile/Skeleton/BasicInfo.skeleton.tsx



function BasicInfoSkeleton() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* RatioBox */.Zeg, {
                ratio: 145 / 390,
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Box */.xuv, {
                    bgcolor: "background.200",
                    width: "100%",
                    height: "100%"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                        variant: "circular",
                        sx: {
                            width: 84,
                            height: 84,
                            mt: "-64px"
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                            variant: "h1",
                            children: "asdasdsadklsajdlaskd"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                            variant: "body2",
                            children: "asdasdsadklsajdlaskd"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                        sx: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                            variant: "body2",
                            children: "Full-Stack Developer upgrading frr"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                        sx: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                            variant: "caption",
                            children: "Full-Stack Developer upgrading frr"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var BasicInfo_skeleton = (BasicInfoSkeleton);

;// CONCATENATED MODULE: ./src/components/Profile/Skeleton/Block.skeleton.tsx



function BlockSkeleton() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Box */.xuv, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
                pt: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Flex */.kCb, {
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                            lines: 1,
                            variant: "body1",
                            bold: true,
                            color: "text.100",
                            children: "title title title title title"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Divider */.izJ, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper/* default */.Z, {
                pt: 4,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                            lines: 1,
                            variant: "body1",
                            bold: true,
                            color: "text.100",
                            children: "title title title title title title title title title title title title title title title title title title title title title title title title title"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                            lines: 1,
                            variant: "body1",
                            bold: true,
                            color: "text.100",
                            children: "title title title title title title title title title title title title title title title title title title title title title title title title title"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                            lines: 1,
                            variant: "body1",
                            bold: true,
                            color: "text.100",
                            children: "title title title title title title title t"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Block_skeleton = (BlockSkeleton);

;// CONCATENATED MODULE: ./src/components/Profile/Skeleton/Profile.skeleton.tsx




function ProfileSkeleton() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
        gap: 1,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicInfo_skeleton, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Block_skeleton, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Block_skeleton, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Block_skeleton, {})
        ]
    });
}
/* harmony default export */ var Profile_skeleton = (ProfileSkeleton);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./src/configs/profile.ts
var profile = __webpack_require__(49054);
// EXTERNAL MODULE: ./src/hooks/profile/useCouldEditProfile.ts
var useCouldEditProfile = __webpack_require__(62570);
// EXTERNAL MODULE: ../../packages/service/pwa/generated/graphql.ts
var graphql = __webpack_require__(51499);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/core/BlockWrapper.tsx





function BlockWrapper(props) {
    var children = props.children, title = props.title, contentProps = props.contentProps, editButton = props.editButton, subtitle = props.subtitle, noDivider = props.noDivider;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Box */.xuv, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
                pt: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Flex */.kCb, {
                            gap: 1,
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                lines: 1,
                                variant: "body1",
                                bold: true,
                                color: "text.100",
                                children: title
                            })
                        }),
                        editButton
                    ]
                })
            }),
            subtitle ? subtitle : !noDivider ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Divider */.izJ, {}) : null,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                pt: 4
            }, contentProps), {
                children: children
            }))
        ]
    });
}
/* harmony default export */ var core_BlockWrapper = (BlockWrapper);

// EXTERNAL MODULE: ./src/components/Profile/blocks/core/EditButton.tsx
var EditButton = __webpack_require__(52012);
// EXTERNAL MODULE: ./src/components/Profile/blocks/core/NFTGrid.tsx
var NFTGrid = __webpack_require__(12406);
// EXTERNAL MODULE: ./src/components/Profile/blocks/core/NFTItem.tsx
var NFTItem = __webpack_require__(19618);
// EXTERNAL MODULE: ./src/components/Profile/blocks/Credential/CredItem.tsx
var CredItem = __webpack_require__(21713);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Credential/index.tsx












var CredentialEditModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2919).then(__webpack_require__.bind(__webpack_require__, 42919));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42919)
            ];
        }
    },
    ssr: false
});
// const EditButton = (props: { profileId: string; data?: CredentialBlock; hidden: boolean }) => {
//   const { data, profileId, hidden } = props;
//   const [isModalOpen, toggleIsModal] = useState(false);
//   const openModal = () => toggleIsModal(true);
//   const closeModal = () => toggleIsModal(false);
//   if (!data || hidden) return null;
//   return (
//     <>
//       <EditIconButton onClick={openModal} />
//       <CredentialEditModal onClose={closeModal} open={isModalOpen} blockData={data} profileId={profileId} />
//     </>
//   );
// };
var credShowLimit = 3;
function Credential(props) {
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var creds = data.galaxyCreds;
    var poaps = data.poaps;
    var ref = (0,react.useState)(false), showMore = ref[0], setShowMore = ref[1];
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    var more = creds ? creds.length - credShowLimit : 0;
    var credentials = more > 0 && !showMore ? creds === null || creds === void 0 ? void 0 : creds.slice(0, credShowLimit) : creds;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core_BlockWrapper, {
        title: (data === null || data === void 0 ? void 0 : data.displayName) || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Credential */.kHU.Credential],
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.ZP, {
            profileId: profileId,
            data: data,
            hidden: !couldEdit,
            isCreate: isCreate,
            Modal: CredentialEditModal
        }),
        contentProps: {
            sx: {
                p: isCreate ? 0 : undefined
            }
        },
        noDivider: isCreate,
        children: [
            creds ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
                p: 2,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        bold: true,
                        children: "Galaxy Credentials"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                        mt: 3,
                        flexWrap: "wrap",
                        rowGap: 1.25,
                        columnGap: 1.5,
                        children: [
                            credentials === null || credentials === void 0 ? void 0 : credentials.map(function(cred, index) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CredItem/* default */.Z, {
                                    name: cred.name,
                                    index: index
                                }, cred.id);
                            }),
                            more > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Button */.zxk, {
                                variant: "outlined",
                                size: "tiny",
                                onClick: function() {
                                    setShowMore(!showMore);
                                },
                                children: showMore ? "Show Less" : "+".concat(more, " More")
                            })
                        ]
                    })
                ]
            }) : null,
            poaps && creds ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Divider */.izJ, {
                sx: {
                    my: 3
                },
                flexItem: true
            }) : null,
            poaps ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        bold: true,
                        children: "POAP"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NFTGrid/* default */.Z, {
                        itemLength: poaps.length,
                        wrapperProps: {
                            mt: 3
                        },
                        children: poaps.map(function(poap, index) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NFTItem/* default */.Z, {
                                imageUrl: poap.imageUrl
                            }, poap.id + index);
                        })
                    })
                ]
            }) : null
        ]
    }, data.id);
}
/* harmony default export */ var blocks_Credential = (Credential);

// EXTERNAL MODULE: ./src/hooks/useModalState.ts
var useModalState = __webpack_require__(51466);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/components/Profile/blocks/core/withForm.tsx
var withForm = __webpack_require__(26164);
// EXTERNAL MODULE: ./src/components/Icons/OrgIcon.tsx
var OrgIcon = __webpack_require__(7558);
// EXTERNAL MODULE: ../../packages/utils/index.ts + 27 modules
var utils = __webpack_require__(26292);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/fromUnixTime/index.js
var fromUnixTime = __webpack_require__(41410);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/getYear/index.js
var getYear = __webpack_require__(81914);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Education/EducationItem.tsx








function EducationItem(props) {
    var data = props.data;
    var onEdit = props.onEdit;
    var couldEdit = (0,hooks_profile/* useCouldEditProfile */.sc)().couldEdit;
    var start = (0,fromUnixTime/* default */.Z)(data.startDate);
    var end = data.endDate ? (0,fromUnixTime/* default */.Z)(data.endDate) : undefined;
    var renderTitle = function() {
        if (!data.degree && !data.fieldOfStudy) return null;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Text */.xvT, {
            variant: "body2",
            color: "text.100",
            children: [
                "".concat(data.degree ? data.degree + " - " : ""),
                data.fieldOfStudy
            ]
        });
    };
    var getHref = function() {
        if (!data.school.twitterId && !data.school.profileId || couldEdit) return "javascript:;";
        if (data.school.profileId) return "/".concat(data.school.profileId);
        return (0,utils/* fixTwitterLink */.YO)({
            id: data.school.twitterId
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: getHref(),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
            gap: 1.5,
            alignItems: "start",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Avatar */.qEK, {
                    sx: {
                        width: 40,
                        height: 40,
                        flexShrink: 0
                    },
                    variant: "rounded",
                    src: data.school.avatar
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
                    gap: 0.5,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                            alignItems: "center",
                            gap: 1,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                    bold: true,
                                    variant: "body1",
                                    color: "text.100",
                                    children: data.school.displayName
                                }),
                                data.school.profileId ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrgIcon/* default */.Z, {
                                    size: 18
                                }) : null
                            ]
                        }),
                        renderTitle(),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Text */.xvT, {
                            variant: "body2",
                            color: "text.250",
                            children: [
                                (0,getYear/* default */.Z)(start),
                                " - ",
                                end ? (0,getYear/* default */.Z)(end) : "Present"
                            ]
                        })
                    ]
                }),
                couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                    name: "icon-edit-line",
                    onClick: function() {
                        return onEdit(data.id);
                    }
                }) : null
            ]
        })
    });
}
/* harmony default export */ var Education_EducationItem = (EducationItem);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Education/index.tsx











var EducationEditor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3258).then(__webpack_require__.bind(__webpack_require__, 63258));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63258)
            ];
        }
    },
    ssr: false
});
function Education(props) {
    var data = props.data, isCreate = props.isCreate, profileId = props.profileId;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    var setValue = (0,index_esm/* useFormContext */.Gc)().setValue;
    var ref = (0,useModalState/* default */.Z)(), isOpen = ref.isOpen, closeModal = ref.closeModal, openModal = ref.openModal;
    var handleEditItem = function(id) {
        setValue("educationId", id);
        openModal();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        title: (data === null || data === void 0 ? void 0 : data.displayName) || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Education */.kHU.Education],
        contentProps: {
            gap: 3,
            sx: {
                p: isCreate ? 0 : undefined
            }
        },
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.ZP, {
            isCreate: true,
            hidden: !couldEdit,
            profileId: profileId,
            data: data,
            Modal: EducationEditor,
            openModal: openModal,
            closeModal: closeModal,
            isModalOpen: isOpen
        }),
        noDivider: isCreate,
        children: !isCreate ? data === null || data === void 0 ? void 0 : data.educations.map(function(edu) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Education_EducationItem, {
                onEdit: handleEditItem,
                data: edu
            }, edu.id);
        }) : null
    }, data === null || data === void 0 ? void 0 : data.id);
}
/* harmony default export */ var blocks_Education = ((0,withForm/* default */.Z)(Education));

// EXTERNAL MODULE: ../../packages/service/api/index.ts
var api = __webpack_require__(58884);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/FeaturedContents/Container.tsx

var Container = (0,cyberlab_uikit_src/* styled */.zop)("a")(function(param) {
    var _theme = param.theme, spacing = _theme.spacing, palette = _theme.palette, shape = _theme.shape;
    var ref;
    return {
        display: "flex",
        textDecoration: "none",
        gap: spacing(3),
        padding: spacing(3),
        border: "1px solid",
        borderColor: (ref = palette.border) === null || ref === void 0 ? void 0 : ref[100],
        borderRadius: shape.borderRadius,
        position: "relative"
    };
});
/* harmony default export */ var FeaturedContents_Container = (Container);

// EXTERNAL MODULE: ../../node_modules/react-twitter-widgets/es/index.js + 1 modules
var es = __webpack_require__(20853);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/FeaturedContents/EmbededTweet.tsx




var getTweetId = function(tweetLink) {
    if (!tweetLink) return "";
    var splitedLink = tweetLink.split("?")[0].split("/");
    return splitedLink[splitedLink.length - 1];
};
var TweetSkeleton = function(param) {
    var isReady = param.isReady;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
        gap: 1,
        sx: {
            display: isReady ? "none" : "flex",
            border: "1px solid",
            borderColor: "border.100",
            borderRadius: 1,
            p: 3
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                alignItems: "center",
                gap: 0.5,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                        variant: "circular",
                        sx: {
                            height: 40,
                            width: 40
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
                        gap: 0.5,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                    variant: "caption",
                                    children: "asdasdsad ka jdl"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                    variant: "caption",
                                    children: "asdasdsad ka "
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                    children: "asdasdsad ka jdl kaasdsad ka jdl kajsd"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                    children: "asdasdsad ka jdl kajsdsad ka jdl kajsd"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                    variant: "caption",
                    children: "asdasda a asd sad k as a sada "
                })
            })
        ]
    });
};
function EmbededTweet(props) {
    var editButton = props.editButton, link = props.link;
    var themeMode = (0,cyberlab_uikit_src/* useTheme */.FgM)().palette.mode;
    var ref = (0,react.useState)(false), isReady = ref[0], toggleIsReady = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Box */.xuv, {
        sx: {
            ".twitter-tweet": {
                margin: "0px !important"
            }
        },
        position: "relative",
        children: [
            editButton,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(es/* Tweet */.tP, {
                onLoad: function() {
                    toggleIsReady(true);
                },
                tweetId: getTweetId(link),
                options: {
                    width: "100%",
                    align: "center",
                    theme: themeMode
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TweetSkeleton, {
                isReady: isReady
            })
        ]
    });
}
/* harmony default export */ var FeaturedContents_EmbededTweet = (EmbededTweet);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/FeaturedContents/EmbeddedBlog.tsx









var EditButtonWrapper = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Box */.xuv, {
        zIndex: 2,
        position: "absolute",
        onClick: function(e) {
            e.preventDefault();
            e.stopPropagation();
            props.onClick();
        },
        top: 0,
        right: 0,
        width: 48,
        height: 48,
        children: props.children
    });
};
var ICON_MAP = new Map([
    [
        graphql/* SuperLinkType.Mirror */._Og.Mirror,
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: "icon-mirror",
            size: 32
        })
    ],
    [
        graphql/* SuperLinkType.Medium */._Og.Medium,
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: "icon-medium",
            size: 32
        })
    ],
    [
        graphql/* SuperLinkType.Tweet */._Og.Tweet,
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: "icon-Twitter",
            size: 32
        })
    ],
    [
        graphql/* SuperLinkType.Youtube */._Og.Youtube,
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: "icon-YouTube",
            size: 32
        })
    ],
    [
        graphql/* SuperLinkType.Substack */._Og.Substack,
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: "icon-substack",
            size: 32
        })
    ],
    [
        graphql/* SuperLinkType.Other */._Og.Other,
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: "icon-link",
            size: 32
        })
    ], 
]);
function EmbeddedBlog(props) {
    var data = props.data, couldEdit = props.couldEdit;
    var onEdit = props.onEdit;
    // 这里是为了兼容link3老的content数据
    var metaData = (0,api/* useGetLinkPreviewQuery */.X3)(encodeURIComponent(data.link), {
        skip: !data.link || data.type === graphql/* SuperLinkType.Tweet */._Og.Tweet || data && !!data.title,
        selectFromResult: function selectFromResult(param) {
            var currentData = param.currentData;
            var ref, ref1;
            return {
                metaData: {
                    title: (currentData === null || currentData === void 0 ? void 0 : currentData.data.title) || "",
                    imageUrl: (currentData === null || currentData === void 0 ? void 0 : (ref = currentData.data) === null || ref === void 0 ? void 0 : ref.img) || "",
                    description: (currentData === null || currentData === void 0 ? void 0 : (ref1 = currentData.data) === null || ref1 === void 0 ? void 0 : ref1.desc) || ""
                }
            };
        }
    }).metaData;
    if (data.type === graphql/* SuperLinkType.Tweet */._Og.Tweet) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedContents_EmbededTweet, {
            link: data.link,
            editButton: onEdit && couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButtonWrapper, {
                onClick: onEdit,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* EditIcon */.dY, {})
            }) : null
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeaturedContents_Container, {
        href: data.link,
        target: "_blank",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
                gap: 1.5,
                width: "50%",
                children: [
                    ICON_MAP.get(data.type),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        lines: 3,
                        variant: "body1",
                        color: "text.100",
                        children: data.title || metaData.title
                    }),
                    data.link && (0,utils/* isValidLink */.lk)(data.link) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        variant: "caption",
                        color: "text.250",
                        children: new URL((0,utils/* fixHttpLink */.WX)(data.link)).hostname
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* RatioBox */.Zeg, {
                ratio: 136 / 156,
                sx: {
                    width: "42%"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Box */.xuv, {
                    flexShrink: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: 1,
                    component: "img",
                    src: data.imageUrl || metaData.imageUrl,
                    sx: {
                        objectFit: "cover"
                    }
                })
            }),
            onEdit && couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButtonWrapper, {
                onClick: onEdit,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* EditIcon */.dY, {})
            }) : null
        ]
    });
}
/* harmony default export */ var FeaturedContents_EmbeddedBlog = (EmbeddedBlog);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/FeaturedContents/index.tsx












var FeaturedContentsEditModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5707).then(__webpack_require__.bind(__webpack_require__, 5707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5707)
            ];
        }
    },
    ssr: false
});
function FeaturedContents(props) {
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    var ref = (0,react.useState)(-1), editingIndex = ref[0], setEditingIndex = ref[1];
    var closeModal = function() {
        return setEditingIndex(-1);
    };
    var addLink = function() {
        var ref;
        setEditingIndex(((ref = data.superLinks) === null || ref === void 0 ? void 0 : ref.length) || 0);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core_BlockWrapper, {
        editButton: couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Button */.zxk, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            size: "small",
            variant: "outlined",
            color: "primary",
            sx: {
                height: 28,
                px: 1,
                flexShrink: 0
            },
            startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
                size: 18,
                name: "icon-add-circle-line",
                mb: 0.25
            }),
            onClick: addLink,
            children: "Add"
        })) : null,
        title: data.displayName || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Superlink */.kHU.Superlink],
        contentProps: {
            sx: {
                gap: 3,
                p: isCreate ? 0 : undefined
            }
        },
        noDivider: isCreate,
        children: [
            !isCreate ? data.superLinks.map(function(superLink, index) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedContents_EmbeddedBlog, {
                    couldEdit: !!couldEdit,
                    data: superLink,
                    onEdit: function() {
                        return setEditingIndex(index);
                    }
                }, superLink.link);
            }) : null,
            couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedContentsEditModal, {
                editingIndex: editingIndex,
                onClose: closeModal,
                open: editingIndex > -1,
                profileId: profileId,
                blockData: data
            }) : null
        ]
    }, data.id);
}
/* harmony default export */ var blocks_FeaturedContents = (FeaturedContents);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/hooks/profile/useUpdateBlockVisibility.ts
var useUpdateBlockVisibility = __webpack_require__(81208);
// EXTERNAL MODULE: ./src/components/Profile/blocks/core/ShowMore.tsx
var ShowMore = __webpack_require__(81330);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 16 modules
var format = __webpack_require__(62650);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Link3Event/EventMiniCard.tsx




var EventMiniCard_Container = (0,cyberlab_uikit_src/* styled */.zop)(cyberlab_uikit_src/* Stack */.Kqy)(function(param) {
    var _theme = param.theme, palette = _theme.palette, shape = _theme.shape, spacing = _theme.spacing;
    var ref;
    return {
        border: "1px solid ".concat((ref = palette.border) === null || ref === void 0 ? void 0 : ref[100]),
        borderRadius: shape.borderRadius,
        padding: spacing(1.5),
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    };
});
function EventMiniCard(param) {
    var event = param.event;
    var ref, ref1, ref2, ref3;
    var hasExtraInfo = ((ref = event.lightInfo) === null || ref === void 0 ? void 0 : ref.hasRaffle) || ((ref1 = event.lightInfo) === null || ref1 === void 0 ? void 0 : ref1.hasW3ST);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventMiniCard_Container, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
                gap: 1,
                width: "75%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        bold: true,
                        color: "text.100",
                        children: event.title
                    }),
                    hasExtraInfo ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                        gap: 0.5,
                        children: [
                            (event === null || event === void 0 ? void 0 : (ref2 = event.lightInfo) === null || ref2 === void 0 ? void 0 : ref2.hasRaffle) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Tag */.Vp9, {
                                containerProps: {
                                    px: 0.5
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                                    name: "icon-gift-line",
                                    size: 18
                                })
                            }),
                            (event === null || event === void 0 ? void 0 : (ref3 = event.lightInfo) === null || ref3 === void 0 ? void 0 : ref3.hasW3ST) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Tag */.Vp9, {
                                containerProps: {
                                    px: 0.5
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                                    name: "icon-W3ST-line",
                                    size: 18
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
                alignItems: "end",
                gap: 0.5,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        variant: "body2",
                        color: "brand.main",
                        bold: true,
                        children: (0,format/* default */.Z)(event.startTimestamp * 1000, "MMM dd")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        variant: "body2",
                        color: "brand.main",
                        children: (0,format/* default */.Z)(event.startTimestamp * 1000, "hh:mm")
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Link3Event_EventMiniCard = (EventMiniCard);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Link3Event/EventList.tsx





function EventList(props) {
    var events = props.events;
    var hasMore = events.length > 3;
    var ref = (0,react.useState)(false), showMore = ref[0], toggleShowMore = ref[1];
    if (events.length < 1) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
            my: 5,
            textAlign: "center",
            color: "text.250",
            children: "No Events"
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            events.slice(0, showMore ? events.length : 3).map(function(event) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link3Event_EventMiniCard, {
                    event: event
                }, event.id);
            }),
            hasMore ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMore/* default */.Z, {
                wrapperProps: {
                    mt: 0
                },
                isShowMore: showMore,
                setShowMore: function() {
                    return toggleShowMore(function(state) {
                        return !state;
                    });
                }
            }) : null
        ]
    });
}
/* harmony default export */ var Link3Event_EventList = (EventList);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Link3Event/index.tsx















var Link3Event_EditButton = function(props) {
    var handle = props.handle, data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var ref = (0,react.useState)(false), isLoading = ref[0], toggleIsLoading = ref[1];
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useUpdateBlockVisibility/* useUpdateBlockVisibility */.I)(), 1), updateVisibility = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks_profile/* useCreateBlocks */.ad)(), 1), createBlock = ref2[0];
    var handleDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        toggleIsLoading(true);
                        _ctx.next = 5;
                        return updateVisibility({
                            handle: handle,
                            id: data.id,
                            visibility: graphql/* BlockVisibility.BlockVisibilityPrivate */.T7W.BlockVisibilityPrivate
                        });
                    case 5:
                        toggleIsLoading(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCreate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        toggleIsLoading(true);
                        _ctx.next = 5;
                        return isCreate ? createBlock({
                            handle: handle,
                            profileId: profileId,
                            input: {
                                displayName: profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Event */.kHU.Event],
                                event: {
                                    enable: true
                                }
                            }
                        }) : updateVisibility({
                            handle: handle,
                            id: data.id,
                            visibility: graphql/* BlockVisibility.BlockVisibilityPublic */.T7W.BlockVisibilityPublic
                        });
                    case 5:
                        toggleIsLoading(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCreate() {
            return _ref.apply(this, arguments);
        };
    }();
    if (isCreate || (data === null || data === void 0 ? void 0 : data.visibility) === graphql/* BlockVisibility.BlockVisibilityPrivate */.T7W.BlockVisibilityPrivate) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* LoadingButton */.flC, {
            loading: isLoading,
            variant: "outlined",
            sx: {
                px: 1,
                height: 28,
                fontSize: 12
            },
            onClick: handleCreate,
            startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                name: "icon-eye-off-line",
                size: 18,
                mt: -0.5
            }),
            children: "Private"
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* LoadingButton */.flC, {
        loading: isLoading,
        variant: "outlined",
        sx: {
            px: 1,
            height: 28,
            fontSize: 12
        },
        startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: "icon-eye-line",
            size: 18,
            mt: -0.5
        }),
        onClick: handleDelete,
        children: "Public"
    });
};
function Link3Event(props) {
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    var query = (0,next_router.useRouter)().query;
    var handle = ((query === null || query === void 0 ? void 0 : query.handle) || "").toString();
    // get orgId
    var orgId = graphql/* api.endpoints.getProfile.useQueryState */.hi0.endpoints.getProfile.useQueryState({
        handle: handle
    }, {
        selectFromResult: function selectFromResult(param) {
            var currentData = param.currentData;
            var ref;
            return {
                orgId: (ref = currentData === null || currentData === void 0 ? void 0 : currentData.profile.data) === null || ref === void 0 ? void 0 : ref.organization.id
            };
        },
        skip: !handle
    }).orgId;
    var _events = (0,graphql/* useGetOrganizationEventsQuery */.wrf)({
        id: orgId,
        first: 6
    }, {
        skip: !orgId || !isCreate,
        selectFromResult: function selectFromResult(param) {
            var currentData = param.currentData;
            var ref;
            return {
                _events: currentData === null || currentData === void 0 ? void 0 : (ref = currentData.organization) === null || ref === void 0 ? void 0 : ref.events.list
            };
        }
    })._events;
    var events = data.events || _events;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        title: data.displayName || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Event */.kHU.Event],
        editButton: couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link3Event_EditButton, {
            data: data,
            profileId: profileId,
            isCreate: isCreate,
            handle: handle
        }) : null,
        contentProps: {
            gap: 3,
            sx: {
                p: isCreate ? 0 : undefined
            }
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link3Event_EventList, {
            events: events || []
        })
    }, data.id);
}
/* harmony default export */ var blocks_Link3Event = (Link3Event);

// EXTERNAL MODULE: ./src/components/PostCard/index.tsx
var PostCard = __webpack_require__(40231);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Link3Post/PostList.tsx





function PostList(props) {
    var posts = props.posts;
    var hasMore = posts.length > 3;
    var ref = (0,react.useState)(false), showMore = ref[0], toggleShowMore = ref[1];
    if (posts.length < 1) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
            my: 5,
            textAlign: "center",
            color: "text.250",
            children: "No Posts"
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Box */.xuv, {
        children: [
            posts.slice(0, showMore ? posts.length : 3).map(function(post) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostCard/* default */.Z, {
                            data: post
                        }, post.id),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Divider */.izJ, {
                            sx: {
                                "&:last-of-type": {
                                    display: "none"
                                },
                                mx: 3
                            }
                        })
                    ]
                });
            }),
            hasMore ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMore/* default */.Z, {
                wrapperProps: {
                    mt: 0,
                    mb: 3
                },
                isShowMore: showMore,
                setShowMore: function() {
                    return toggleShowMore(function(state) {
                        return !state;
                    });
                }
            }) : null
        ]
    });
}
/* harmony default export */ var Link3Post_PostList = (PostList);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Link3Post/index.tsx















var Link3Post_EditButton = function(props) {
    var handle = props.handle, data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var ref = (0,react.useState)(false), isLoading = ref[0], toggleIsLoading = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useUpdateBlockVisibility/* useUpdateBlockVisibility */.I)(), 1), updateVisibility = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks_profile/* useCreateBlocks */.ad)(), 1), createBlock = ref2[0];
    var handleDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        toggleIsLoading(true);
                        _ctx.next = 5;
                        return updateVisibility({
                            handle: handle,
                            id: data.id,
                            visibility: graphql/* BlockVisibility.BlockVisibilityPrivate */.T7W.BlockVisibilityPrivate
                        });
                    case 5:
                        toggleIsLoading(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCreate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        toggleIsLoading(true);
                        _ctx.next = 5;
                        return isCreate ? createBlock({
                            handle: handle,
                            profileId: profileId,
                            input: {
                                displayName: profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Posts */.kHU.Posts],
                                post: {
                                    enable: true
                                }
                            }
                        }) : updateVisibility({
                            handle: handle,
                            id: data.id,
                            visibility: graphql/* BlockVisibility.BlockVisibilityPublic */.T7W.BlockVisibilityPublic
                        });
                    case 5:
                        toggleIsLoading(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCreate() {
            return _ref.apply(this, arguments);
        };
    }();
    if (isCreate || (data === null || data === void 0 ? void 0 : data.visibility) === graphql/* BlockVisibility.BlockVisibilityPrivate */.T7W.BlockVisibilityPrivate) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* LoadingButton */.flC, {
            loading: isLoading,
            variant: "outlined",
            sx: {
                px: 1,
                height: 28,
                fontSize: 12
            },
            onClick: handleCreate,
            startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                name: "icon-eye-off-line",
                size: 18,
                mt: -0.5
            }),
            children: "Private"
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* LoadingButton */.flC, {
        loading: isLoading,
        variant: "outlined",
        sx: {
            px: 1,
            height: 28,
            fontSize: 12
        },
        startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: "icon-eye-line",
            size: 18,
            mt: -0.5
        }),
        onClick: handleDelete,
        children: "Public"
    });
};
function Link3Post(props) {
    var ref;
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    var query = (0,next_router.useRouter)().query;
    var handle = ((query === null || query === void 0 ? void 0 : query.handle) || "").toString();
    var _posts = (0,graphql/* useOrgPostsQuery */.C8y)({
        handle: handle,
        first: 6
    }, {
        skip: !handle || !isCreate,
        selectFromResult: function selectFromResult(param) {
            var currentData = param.currentData;
            var ref, ref1;
            return {
                _posts: (ref = currentData === null || currentData === void 0 ? void 0 : currentData.profile.data) === null || ref === void 0 ? void 0 : (ref1 = ref.creator) === null || ref1 === void 0 ? void 0 : ref1.posts.list
            };
        }
    })._posts;
    var posts = (data === null || data === void 0 ? void 0 : (ref = data.postPage) === null || ref === void 0 ? void 0 : ref.list) || _posts;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        title: data.displayName || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Posts */.kHU.Posts],
        editButton: couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link3Post_EditButton, {
            isCreate: isCreate,
            data: data,
            profileId: profileId,
            handle: handle
        }) : null,
        contentProps: {
            sx: {
                p: 0
            }
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link3Post_PostList, {
            posts: posts || []
        })
    }, data.id);
}
/* harmony default export */ var blocks_Link3Post = (Link3Post);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Links/index.tsx










var LinksEdit = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1941).then(__webpack_require__.bind(__webpack_require__, 21941));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21941)
            ];
        }
    },
    ssr: false
});
var LinkItem = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
        flexDirection: "row",
        component: "a",
        href: (0,utils/* fixHttpLink */.WX)(data.link),
        target: "_blank",
        alignItems: "center",
        justifyContent: "space-between",
        sx: {
            textDecoration: "none"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                variant: "body1",
                color: "text.100",
                children: data.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                name: "icon-arrow-tiny-right"
            })
        ]
    });
};
function Links(props) {
    var ref;
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        title: (data === null || data === void 0 ? void 0 : data.displayName) || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Link */.kHU.Link],
        contentProps: {
            gap: 5,
            sx: {
                p: isCreate ? 0 : undefined
            }
        },
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.ZP, {
            profileId: profileId,
            data: data,
            hidden: !couldEdit,
            Modal: LinksEdit,
            isCreate: isCreate
        }),
        noDivider: isCreate,
        children: data === null || data === void 0 ? void 0 : (ref = data.links) === null || ref === void 0 ? void 0 : ref.map(function(link, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkItem, {
                data: link
            }, index);
        })
    }, data === null || data === void 0 ? void 0 : data.id);
}
/* harmony default export */ var blocks_Links = (Links);

// EXTERNAL MODULE: ./src/components/Profile/blocks/core/ProfileForm.drawer.tsx + 3 modules
var ProfileForm_drawer = __webpack_require__(94927);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./src/hooks/index.ts + 10 modules
var hooks = __webpack_require__(68062);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(94449);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/NFTs/getUniqueNFTId.ts
function getUniqueNFTId(nft) {
    return "token_id" in nft ? "".concat(nft.contract_address, "-").concat(nft.token_id) : "".concat(nft.contract, "-").concat(nft.tokenId);
};

;// CONCATENATED MODULE: ./src/components/Profile/blocks/NFTs/NFTs.edit/NftCollection.tsx




var Title = function(props) {
    var isAllSelected = props.isAllSelected, isOpen = props.isOpen, collectionName = props.collectionName;
    var onClick = props.onClick, onSelectedAll = props.onSelectedAll;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
        onClick: onClick,
        justifyContent: "space-between",
        p: 3,
        borderBottom: isOpen ? "1px solid" : "none",
        borderColor: "border.100",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                lines: 1,
                variant: "body1",
                children: collectionName
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                name: "icon-arrrow-tiny-up",
                sx: {
                    transform: !isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "all 0.3s"
                }
            })
        ]
    });
};
function NftCollection(props) {
    var collection = props.collection, renderNFTs = props.renderNFTs, onSelectedAll = props.onSelectedAll;
    var ref = (0,react.useState)(false), isOpen = ref[0], toggleIsOpen = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Box */.xuv, {
        bgcolor: "bg.paper",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                collectionName: collection.collection_name,
                isAllSelected: true,
                isOpen: isOpen,
                // onSelectedAll={() => onSelectedAll(collection)}
                onClick: function() {
                    toggleIsOpen(function(state) {
                        return !state;
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Collapse */.UO1, {
                in: isOpen,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Box */.xuv, {
                    p: 3,
                    sx: {
                        display: "grid",
                        gap: 3,
                        gridTemplateColumns: "repeat(3, 1fr)"
                    },
                    children: renderNFTs(collection.assets)
                })
            })
        ]
    });
}
/* harmony default export */ var NFTs_edit_NftCollection = (NftCollection);

// EXTERNAL MODULE: ./src/components/Profile/blocks/NFTs/NFTs.edit/SelectableNFTItem.tsx
var SelectableNFTItem = __webpack_require__(31623);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/NFTs/NFTs.edit/Content.tsx













var NFT_LIMIT = 50;
function Content(props) {
    var ref, ref1;
    var data = props.data;
    var ref2 = (0,hooks/* useAddresses */.Jz)(), eoa = ref2.eoa, assetWallets = ref2.assetWallets;
    var push = (0,next_router.useRouter)().push;
    var nfts = ((ref = (0,react_redux_es/* useSelector */.v9)(api/* default.endpoints.retriveAllNFTByAddress.select */.ZP.endpoints.retriveAllNFTByAddress.select(assetWallets.join(",")))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.nfts) || [];
    var ref3 = (0,index_esm/* useFormContext */.Gc)(), control = ref3.control, handleSubmit = ref3.handleSubmit;
    var ref4 = (0,index_esm/* useController */.bc)({
        name: "nft.nfts",
        defaultValue: data,
        control: control,
        rules: {
            validate: {
                validateSelected: function validateSelected(value) {
                    return value && value.length > 0 || "should select al least 1 NFT item";
                }
            }
        }
    }), _field = ref4.field, onChange = _field.onChange, selected = _field.value, error = ref4.fieldState.error;
    var ref5 = (0,react.useState)(selected || []), selectedNFTs = ref5[0], setSelectedNFTs = ref5[1];
    var selectedNFTIds = (selected || []).map(getUniqueNFTId);
    var appendItem = function(nft) {
        var newNfts = (0,_to_consumable_array/* default */.Z)(selectedNFTs).concat([
            nft
        ]);
        setSelectedNFTs(newNfts);
        onChange && onChange(newNfts);
    };
    var removeItem = function(id) {
        var newNfts = selectedNFTs.filter(function(item) {
            return getUniqueNFTId(item) != id;
        });
        setSelectedNFTs(newNfts);
        onChange && onChange(newNfts);
    };
    var handleSelect = function(nft) {
        var value = {
            tokenId: nft.token_id,
            imageUrl: nft.image_uri,
            name: nft.name,
            ercType: nft.erc_type,
            contract: nft.contract_address,
            owner: nft.owner
        };
        if (selectedNFTIds.includes(getUniqueNFTId(nft))) return removeItem(getUniqueNFTId(nft));
        if (selectedNFTIds.length >= NFT_LIMIT) return;
        appendItem(value);
    };
    (0,react.useEffect)(function() {
        if (error === null || error === void 0 ? void 0 : error.message) {
            cyberlab_uikit_src/* toast.error */.Amu.error(error.message, {
                autoClose: 2000
            });
        }
    }, [
        error
    ]);
    var renderNFTs = function(NFTs) {
        return NFTs.map(function(nft) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectableNFTItem/* default */.Z, {
                name: nft.name,
                imageUrl: nft.image_uri,
                onSelect: function() {
                    return handleSelect(nft);
                },
                isSelected: selectedNFTIds.includes(getUniqueNFTId(nft)),
                sequence: selectedNFTIds.indexOf(getUniqueNFTId(nft)) + 1
            });
        });
    };
    if (nfts.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
            height: "80vh",
            alignItems: "center",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    src: "/assets/bg/nft-nodata.svg",
                    width: 256,
                    height: 170
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                    my: 1.5,
                    bold: true,
                    textAlign: "center",
                    children: "Nothing here"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                    textAlign: "center",
                    mb: 5.5,
                    variant: "body2",
                    color: "text.250",
                    children: "You can add digital assets from another wallet"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Button */.zxk, {
                    sx: {
                        width: 190
                    },
                    variant: "outlined",
                    color: "primary",
                    onClick: function() {
                        return push("/me/cyber-account");
                    },
                    children: "Bundle Wallet"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Stack */.Kqy, {
        mt: 1,
        gap: 1,
        children: nfts.map(function(collection, i) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NFTs_edit_NftCollection, {
                renderNFTs: renderNFTs,
                collection: collection
            }, collection.contract_address + i);
        })
    });
}
/* harmony default export */ var NFTs_edit_Content = (Content);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/NFTs/NFTs.edit/index.tsx








function NFTsEditModal(props) {
    var blockData = props.blockData;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileForm_drawer/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: (blockData === null || blockData === void 0 ? void 0 : blockData.displayName) || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.NftGallery */.kHU.NftGallery]
    }, props), {
        blockData: blockData,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NFTs_edit_Content, {
            data: (blockData === null || blockData === void 0 ? void 0 : blockData.nfts) || []
        })
    }));
}
/* harmony default export */ var NFTs_edit = ((0,withForm/* default */.Z)(NFTsEditModal));

;// CONCATENATED MODULE: ./src/components/Profile/blocks/NFTs/index.tsx









function NFT(props) {
    var ref, ref1;
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var couldEdit = (0,hooks_profile/* useCouldEditProfile */.sc)().couldEdit;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.ZP, {
            hidden: !couldEdit,
            data: data,
            profileId: profileId,
            isCreate: isCreate,
            Modal: NFTs_edit
        }),
        title: data.displayName || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.NftGallery */.kHU.NftGallery],
        contentProps: {
            sx: {
                p: isCreate ? 0 : undefined
            }
        },
        noDivider: isCreate,
        children: !isCreate ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NFTGrid/* default */.Z, {
            itemLength: (ref = data.nfts) === null || ref === void 0 ? void 0 : ref.length,
            children: (ref1 = data.nfts) === null || ref1 === void 0 ? void 0 : ref1.map(function(nft, i) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NFTItem/* default */.Z, {
                    imageUrl: nft.imageUrl,
                    name: nft.name
                }, nft.tokenId + i);
            })
        }) : null
    }, data.id);
}
/* harmony default export */ var NFTs = (NFT);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/OpenSea/OpenSeaItem.tsx





var getOSCollectionLink = function(slug) {
    return slug ? "https://opensea.io/collection/".concat(slug) : "";
};
var OpenSeaItem_Container = (0,cyberlab_uikit_src/* styled */.zop)(cyberlab_uikit_src/* Stack */.Kqy)(function(param) {
    var _theme = param.theme, palette = _theme.palette, shape = _theme.shape, spacing = _theme.spacing;
    var ref;
    return {
        border: "1px solid ".concat((ref = palette.bg) === null || ref === void 0 ? void 0 : ref[100]),
        borderRadius: shape.borderRadius,
        padding: spacing(1.5),
        gap: spacing(3)
    };
});
var CollectionStatsItem = function(props) {
    var isLoading = props.isLoading, symbol = props.symbol, number = props.number, title = props.title, sx = props.sx;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
        width: "25%",
        flexShrink: 1,
        gap: 0.5,
        sx: (0,_object_spread/* default */.Z)({
            "&:not(&:last-of-type)": {
                borderRight: "1px solid",
                borderColor: "border.100"
            }
        }, sx),
        children: [
            isLoading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Skeleton */.OdW, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                    bold: true,
                    variant: "body2",
                    color: "#fff",
                    children: "Link3"
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Text */.xvT, {
                bold: true,
                variant: "body2",
                color: "#fff",
                children: [
                    number,
                    " ",
                    symbol
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                variant: "caption",
                color: "text.250",
                children: title
            })
        ]
    });
};
function OpenSeaItem(props) {
    var ref, ref1, ref2, ref3;
    var slug = props.slug;
    var ref4 = (0,api/* useGetCollectionBySlugQuery */.LT)(slug, {
        skip: !slug,
        selectFromResult: function selectFromResult(param) {
            var data = param.data, isFetching = param.isFetching;
            return {
                data: data || {},
                isFetching: isFetching
            };
        }
    }), data = ref4.data, isFetching = ref4.isFetching;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OpenSeaItem_Container, {
        onClick: function() {
            return window.open(getOSCollectionLink(slug));
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                gap: 1.5,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Avatar */.qEK, {
                        sx: {
                            width: 64,
                            height: 64
                        },
                        variant: "rounded",
                        src: data === null || data === void 0 ? void 0 : data.cover
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
                        gap: 0.5,
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                bold: true,
                                variant: "body1",
                                color: "#fff",
                                children: data === null || data === void 0 ? void 0 : data.name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                lines: 3,
                                variant: "body2",
                                color: "text.250",
                                children: data === null || data === void 0 ? void 0 : data.description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                gap: 0.5,
                mt: 2,
                flexWrap: "nowrap",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionStatsItem, {
                        isLoading: isFetching,
                        symbol: data === null || data === void 0 ? void 0 : data.paymentTokens,
                        number: (ref = data.stats) === null || ref === void 0 ? void 0 : ref.floor,
                        title: "Floor"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionStatsItem, {
                        isLoading: isFetching,
                        symbol: data.paymentTokens,
                        number: (0,utils/* formatNumber */.uf)(Number(Number((ref1 = data.stats) === null || ref1 === void 0 ? void 0 : ref1.totalVolume).toFixed(0))),
                        title: "Total Volume"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionStatsItem, {
                        isLoading: isFetching,
                        number: (0,utils/* formatNumber */.uf)((ref2 = data.stats) === null || ref2 === void 0 ? void 0 : ref2.itemCount),
                        title: "Items"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionStatsItem, {
                        isLoading: isFetching,
                        number: (0,utils/* formatNumber */.uf)((ref3 = data.stats) === null || ref3 === void 0 ? void 0 : ref3.ownersCount),
                        title: "Owners"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var OpenSea_OpenSeaItem = (OpenSeaItem);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/OpenSea/index.tsx








var EditModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4711).then(__webpack_require__.bind(__webpack_require__, 44711));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44711)
            ];
        }
    },
    ssr: false
});
function OpenSea(props) {
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.ZP, {
            profileId: profileId,
            data: data,
            hidden: !couldEdit,
            isCreate: isCreate,
            Modal: EditModal
        }),
        title: (data === null || data === void 0 ? void 0 : data.displayName) || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.NftCollection */.kHU.NftCollection],
        contentProps: {
            sx: {
                gap: 3,
                p: isCreate ? 0 : undefined
            }
        },
        noDivider: isCreate,
        children: !isCreate ? data.slugs.map(function(slug) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpenSea_OpenSeaItem, {
                slug: slug
            }, slug);
        }) : null
    }, data === null || data === void 0 ? void 0 : data.id);
}
/* harmony default export */ var blocks_OpenSea = (OpenSea);

// EXTERNAL MODULE: ./src/components/Profile/blocks/Skills/SkillTag.tsx
var SkillTag = __webpack_require__(2304);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Skills/index.tsx










var SkillsEditor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4482).then(__webpack_require__.bind(__webpack_require__, 4482));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4482)
            ];
        }
    },
    ssr: false
});
var SkillListModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6601).then(__webpack_require__.bind(__webpack_require__, 46601));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46601)
            ];
        }
    },
    ssr: false
});
var SkillDetailModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3894).then(__webpack_require__.bind(__webpack_require__, 83894));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83894)
            ];
        }
    },
    ssr: false
});
function Skills(props) {
    var isCreate = props.isCreate, profileId = props.profileId, data = props.data;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    var ref = (0,react.useState)(false), isListModalOpen = ref[0], toggleIsListModalOpen = ref[1];
    var ref1 = (0,react.useState)(), selectedSkill = ref1[0], setSelectedSkill = ref1[1];
    var openListModal = function() {
        return toggleIsListModalOpen(true);
    };
    var closeListModal = function() {
        return toggleIsListModalOpen(false);
    };
    var openDetailModal = function(skill) {
        return setSelectedSkill(skill);
    };
    var closeDetailModal = function() {
        return setSelectedSkill(undefined);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core_BlockWrapper, {
        editButton: couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.ZP, {
            data: data,
            hidden: !couldEdit,
            isCreate: isCreate,
            profileId: profileId,
            Modal: SkillsEditor
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: "icon-arrow-tiny-right",
            size: 24,
            onClick: openListModal
        }),
        title: profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Skill */.kHU.Skill],
        contentProps: {
            flexDirection: "row",
            gap: 1.5,
            flexWrap: "wrap",
            sx: {
                p: isCreate ? 0 : null
            }
        },
        noDivider: isCreate,
        children: [
            !isCreate ? data === null || data === void 0 ? void 0 : data.skills.map(function(skill) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkillTag/* default */.Z, {
                    data: skill,
                    onClick: function() {
                        return openDetailModal(skill);
                    }
                }, skill.id);
            }) : null,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkillListModal, {
                profileId: profileId,
                open: isListModalOpen,
                blockData: data,
                onClose: closeListModal,
                onSkillTagClick: openDetailModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkillDetailModal, {
                profileId: profileId,
                open: !!selectedSkill,
                data: selectedSkill,
                onClose: closeDetailModal
            })
        ]
    });
}
/* harmony default export */ var blocks_Skills = (Skills);

// EXTERNAL MODULE: ../../packages/service/snapshot/generated/graphql.ts
var generated_graphql = __webpack_require__(68558);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/formatDistance/index.js
var formatDistance = __webpack_require__(40363);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Snapshot/Proposal.tsx



var getProposalLink = function(id, spaceId) {
    return "https://snapshot.org/#/".concat(spaceId, "/proposal/").concat(id);
};
var Proposal_Container = (0,cyberlab_uikit_src/* styled */.zop)(cyberlab_uikit_src/* Stack */.Kqy)(function(param) {
    var _theme = param.theme, palette = _theme.palette, shape = _theme.shape, spacing = _theme.spacing;
    var ref;
    return {
        border: "1px solid ".concat((ref = palette.bg) === null || ref === void 0 ? void 0 : ref[100]),
        borderRadius: shape.borderRadius,
        padding: spacing(1.5),
        gap: spacing(1.5)
    };
});
var StatusTag = function(props) {
    var status = props.status;
    var color = status === "active" ? "success.main" : "text.250";
    var bgcolor = status === "active" ? "rgba(144, 222, 83, 0.10)" : "rgba(255, 255, 255, 0.10)";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Flex */.kCb, {
        bgcolor: bgcolor,
        py: 0.5,
        px: 1,
        alignItems: "center",
        border: "1px solid",
        borderRadius: 1,
        borderColor: color,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
            variant: "caption",
            textTransform: "capitalize",
            color: color,
            children: status
        })
    });
};
var ProposalTime = function(props) {
    var status = props.status, end = props.end;
    var getOffset = function() {
        var current = new Date().getTime();
        return (0,formatDistance/* default */.Z)(current, end * 1000);
    };
    var tag = status === "active" ? "left" : "ago";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Text */.xvT, {
        variant: "caption",
        color: "text.250",
        children: [
            getOffset(),
            " ",
            tag,
            "s"
        ]
    });
};
var Status = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusTag, {
                status: props.status
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProposalTime, {
                status: props.status,
                end: props.end || 0
            })
        ]
    });
};
function Proposal(props) {
    var data = props.data, spaceId = props.spaceId;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Proposal_Container, {
        onClick: function() {
            return window.open(getProposalLink(data.id || "", spaceId || ""));
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                bold: true,
                variant: "body1",
                children: data.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                lines: 3,
                color: "text.250",
                variant: "body2",
                children: data.body || data.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Status, {
                status: data.state,
                end: data.end
            })
        ]
    });
}
/* harmony default export */ var Snapshot_Proposal = (Proposal);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Snapshot/SnapshotContent.tsx





function SnapshotContent(props) {
    var spaceId = props.spaceId;
    var _ref = (0,generated_graphql/* useGetProposalsInSpaceQuery */.rp)({
        spaceId: spaceId
    }, {
        skip: !spaceId,
        selectFromResult: function selectFromResult(_param) {
            var data = _param.data, rest = (0,src_object_without_properties/* default */.Z)(_param, [
                "data"
            ]);
            return (0,_object_spread/* default */.Z)({
                proposals: (data === null || data === void 0 ? void 0 : data.proposals) || []
            }, rest);
        }
    }), proposals = _ref.proposals, isFetching = _ref.isFetching;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: proposals.map(function(proposal) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Snapshot_Proposal, {
                data: proposal,
                spaceId: spaceId
            }, proposal.id);
        })
    });
}
/* harmony default export */ var Snapshot_SnapshotContent = (SnapshotContent);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Snapshot/index.tsx








var SnapshotEdit = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1898).then(__webpack_require__.bind(__webpack_require__, 71898));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71898)
            ];
        }
    },
    ssr: false
});
function Snapshot(props) {
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.ZP, {
            profileId: profileId,
            data: data,
            hidden: !couldEdit,
            isCreate: isCreate,
            Modal: SnapshotEdit
        }),
        title: (data === null || data === void 0 ? void 0 : data.displayName) || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Snapshot */.kHU.Snapshot],
        contentProps: {
            sx: {
                gap: 3,
                p: isCreate ? 0 : undefined
            }
        },
        noDivider: isCreate,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Snapshot_SnapshotContent, {
            spaceId: data.spaceId
        })
    }, data === null || data === void 0 ? void 0 : data.id);
}
/* harmony default export */ var blocks_Snapshot = (Snapshot);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Twitter/TwitterItem.tsx




function TwitterItem(props) {
    var data = props.data;
    var getLink = function() {
        if (data.profileId) {
            return (0,utils/* getProfileRouter */.z)(data.profileId);
        } else {
            return (0,utils/* fixTwitterLink */.YO)({
                id: data.twitterId
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: getLink(),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
            gap: 1,
            alignItems: "center",
            width: "100%",
            overflow: "hidden",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Avatar */.qEK, {
                    sx: {
                        width: 40,
                        height: 40,
                        flexShrink: 0
                    },
                    src: data.avatar
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                    noWrap: true,
                    variant: "body1",
                    color: "text.100",
                    width: "100%",
                    textAlign: "center",
                    children: data.displayName
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                    noWrap: true,
                    variant: "body2",
                    color: "text.250",
                    mt: -0.5,
                    width: "100%",
                    textAlign: "center",
                    children: data.title
                })
            ]
        })
    });
}
/* harmony default export */ var Twitter_TwitterItem = (TwitterItem);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Twitter/index.tsx









var TwitterEdit = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4081).then(__webpack_require__.bind(__webpack_require__, 4081));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4081)
            ];
        }
    },
    ssr: false
});
function Twitter(props) {
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        title: data.displayName || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Twitter */.kHU.Twitter],
        contentProps: {
            gap: 4,
            sx: {
                p: isCreate ? 0 : undefined
            }
        },
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.ZP, {
            hidden: !couldEdit,
            data: data,
            profileId: profileId,
            isCreate: isCreate,
            Modal: TwitterEdit
        }),
        noDivider: isCreate,
        children: !isCreate ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NFTGrid/* default */.Z, {
            itemLength: data.twitters.length > 6 ? data.twitters.length : 6,
            children: data.twitters.map(function(tw) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Twitter_TwitterItem, {
                    data: tw
                }, tw.profileId);
            })
        }) : null
    }, data.id);
}
/* harmony default export */ var blocks_Twitter = (Twitter);

// EXTERNAL MODULE: ./src/components/Profile/blocks/W3st/W3stItem.tsx
var W3stItem = __webpack_require__(56163);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/W3st/index.tsx









var W3stEditModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 544).then(__webpack_require__.bind(__webpack_require__, 80544));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80544)
            ];
        }
    },
    ssr: false
});
function W3st(props) {
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        title: data.displayName || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.W3StGallery */.kHU.W3StGallery],
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.ZP, {
            hidden: !couldEdit,
            data: data,
            profileId: profileId,
            isCreate: isCreate,
            Modal: W3stEditModal
        }),
        noDivider: isCreate,
        contentProps: {
            sx: {
                p: isCreate ? 0 : undefined
            }
        },
        children: !isCreate ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NFTGrid/* default */.Z, {
            itemLength: data.tokenUris.length,
            children: data.tokenUris.map(function(tokenUri) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(W3stItem/* default */.Z, {
                    tokenUri: tokenUri
                }, tokenUri);
            })
        }) : null
    }, data.id);
}
/* harmony default export */ var blocks_W3st = (W3st);

// EXTERNAL MODULE: ./src/components/Profile/blocks/core/date.ts
var date = __webpack_require__(33670);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Work/WorkItem.tsx









function WorkItem(props) {
    var data = props.data;
    var onEdit = props.onEdit;
    var couldEdit = (0,hooks_profile/* useCouldEditProfile */.sc)().couldEdit;
    var start = (0,fromUnixTime/* default */.Z)(data.startDate);
    var end = data.endDate ? (0,fromUnixTime/* default */.Z)(data.endDate) : undefined;
    var getHref = function() {
        if (!data.organization.twitterId && !data.organization.profileId || couldEdit) return "javascript:;";
        if (data.organization.profileId) return "/".concat(data.organization.profileId);
        return (0,utils/* fixTwitterLink */.YO)({
            id: data.organization.twitterId
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: getHref(),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
            gap: 1.5,
            alignItems: "start",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Avatar */.qEK, {
                    sx: {
                        width: 40,
                        height: 40,
                        flexShrink: 0
                    },
                    variant: "rounded",
                    src: data.organization.avatar
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
                    gap: 0.5,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                            gap: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                    bold: true,
                                    variant: "body1",
                                    color: "text.100",
                                    children: data.organization.displayName
                                }),
                                data.organization.profileId ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrgIcon/* default */.Z, {
                                    size: 18
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                            variant: "body2",
                            color: "text.100",
                            children: data.organization.title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                            variant: "body2",
                            color: "text.250",
                            children: (0,date/* formatTime */.m)(start, end)
                        })
                    ]
                }),
                couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                    name: "icon-edit-line",
                    onClick: function() {
                        return onEdit(data.id);
                    }
                }) : null
            ]
        })
    });
}
/* harmony default export */ var Work_WorkItem = (WorkItem);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Work/index.tsx











var WorkEditor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7801).then(__webpack_require__.bind(__webpack_require__, 37801));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37801)
            ];
        }
    },
    ssr: false
});
function Works(props) {
    var data = props.data, isCreate = props.isCreate, profileId = props.profileId;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    var setValue = (0,index_esm/* useFormContext */.Gc)().setValue;
    var ref = (0,useModalState/* default */.Z)(), isOpen = ref.isOpen, closeModal = ref.closeModal, openModal = ref.openModal;
    var handleEditItem = function(id) {
        setValue("workExperienceId", id);
        openModal();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        title: (data === null || data === void 0 ? void 0 : data.displayName) || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.WorkExperience */.kHU.WorkExperience],
        contentProps: {
            gap: 3,
            sx: {
                p: isCreate ? 0 : undefined
            }
        },
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.ZP, {
            hidden: !couldEdit,
            profileId: profileId,
            isCreate: true,
            Modal: WorkEditor,
            data: data,
            openModal: openModal,
            closeModal: closeModal,
            isModalOpen: isOpen
        }),
        noDivider: isCreate,
        children: !isCreate ? data === null || data === void 0 ? void 0 : data.workExperiences.map(function(exp) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Work_WorkItem, {
                onEdit: handleEditItem,
                data: exp
            }, exp.id);
        }) : null
    }, data.id);
}
/* harmony default export */ var Work = ((0,withForm/* default */.Z)(Works));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/utils/github.ts
var github = __webpack_require__(91595);
// EXTERNAL MODULE: ./src/utils/twitter.ts
var twitter = __webpack_require__(51357);
// EXTERNAL MODULE: ../../node_modules/react-linkedin-login-oauth2/build/index.esm.js
var build_index_esm = __webpack_require__(11436);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Contact/useSocialMediaInfo.ts














var _obj;
var LINKS = (_obj = {}, (0,_define_property/* default */.Z)(_obj, graphql/* ContactType.Email */.uCS.Email, function(name) {
    return undefined;
}), (0,_define_property/* default */.Z)(_obj, graphql/* ContactType.Twitter */.uCS.Twitter, function(id) {
    return (0,utils/* fixTwitterLink */.YO)({
        id: id
    });
}), (0,_define_property/* default */.Z)(_obj, graphql/* ContactType.Linkedin */.uCS.Linkedin, function(name) {
    return "https://www.linkedin.com/in/".concat(name);
}), (0,_define_property/* default */.Z)(_obj, graphql/* ContactType.Github */.uCS.Github, function(name) {
    return "https://github.com/".concat(name);
}), _obj);
var _obj1;
var LOGIN_TYPE = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, graphql/* ContactType.Email */.uCS.Email, graphql/* LoginType.EmailLogin */.BzC.EmailLogin), (0,_define_property/* default */.Z)(_obj1, graphql/* ContactType.Twitter */.uCS.Twitter, graphql/* LoginType.TwitterLogin */.BzC.TwitterLogin), (0,_define_property/* default */.Z)(_obj1, graphql/* ContactType.Linkedin */.uCS.Linkedin, graphql/* LoginType.LinkedinLogin */.BzC.LinkedinLogin), (0,_define_property/* default */.Z)(_obj1, graphql/* ContactType.Github */.uCS.Github, graphql/* LoginType.GithubLogin */.BzC.GithubLogin), _obj1);
function useSocialMediaInfo(params) {
    var name = params.name, contactType = params.contactType;
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useLazyMeQuery */.lHT)(), 1), updateMeData = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useLinkWeb2Mutation */.NWA)(), 2), linker = ref1[0], isLoading = ref1[1].isLoading;
    var linkedInredirectUri = "".concat( true && window.location.origin, "/redirect/linkedin");
    var linkedInLogin = (0,build_index_esm/* useLinkedIn */.HL)({
        clientId: "86z8no8b20k6qp",
        scope: "profile openid r_basicprofile r_1st_connections_size",
        redirectUri: linkedInredirectUri,
        onSuccess: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(code) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return linker({
                                type: graphql/* LoginType.LinkedinLogin */.BzC.LinkedinLogin,
                                token: "",
                                twitterOAuthCode: {
                                    code: "",
                                    redirectUri: ""
                                },
                                linkedInOAuth: {
                                    code: code,
                                    redirectUri: linkedInredirectUri
                                }
                            });
                        case 2:
                            res = _ctx.sent;
                            if (!("data" in res)) {
                                _ctx.next = 15;
                                break;
                            }
                            if (!(res.data.linkWeb2.status === graphql/* LinkWeb2Response_Status.Success */.M0W.Success)) {
                                _ctx.next = 9;
                                break;
                            }
                            _ctx.next = 7;
                            return updateMeData();
                        case 7:
                            _ctx.next = 15;
                            break;
                        case 9:
                            _ctx.t0 = res.data.linkWeb2.status;
                            _ctx.next = _ctx.t0 === graphql/* LinkWeb2Response_Status.LinkedinUsed */.M0W.LinkedinUsed ? 12 : 14;
                            break;
                        case 12:
                            cyberlab_uikit_src/* toast.error */.Amu.error("LinkedIn Account is already used, please try another one.");
                            return _ctx.abrupt("break", 15);
                        case 14:
                            cyberlab_uikit_src/* toast.error */.Amu.error("Something went wrong, please try again later.");
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(code) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error) {
            console.log(error);
        }
    }).linkedInLogin;
    var ref2 = (0,hooks/* useLinkEmailModal */.hY)(), openLinkEmailModal = ref2.open;
    var twitterInfo = (0,graphql/* useGetTwitterInfoByIdQuery */.yxR)({
        twitterId: name
    }, {
        skip: contactType !== graphql/* ContactType.Twitter */.uCS.Twitter,
        selectFromResult: function selectFromResult(param) {
            var currentData = param.currentData;
            return {
                twitterInfo: contactType !== graphql/* ContactType.Twitter */.uCS.Twitter ? undefined : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    handle: (currentData === null || currentData === void 0 ? void 0 : currentData.getTwitterHandleById.twitterHandle) ? "@".concat(currentData === null || currentData === void 0 ? void 0 : currentData.getTwitterHandleById.twitterHandle) : "",
                    url: LINKS[contactType](name)
                })
            };
        }
    }).twitterInfo;
    var link = (0,react.useCallback)(function() {
        switch(contactType){
            case graphql/* ContactType.Linkedin */.uCS.Linkedin:
                linkedInLogin();
                break;
            case graphql/* ContactType.Email */.uCS.Email:
                openLinkEmailModal({
                    successCallback: updateMeData
                });
                break;
            case graphql/* ContactType.Github */.uCS.Github:
                (0,github/* redirectGetGithubCode */.k)();
                break;
            case graphql/* ContactType.Twitter */.uCS.Twitter:
                (0,twitter/* redirectGetTwitterCode */.vB)();
                break;
            default:
                break;
        }
    }, [
        contactType
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, twitterInfo || (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
        handle: params.name,
        url: LINKS[contactType](name)
    })), {
        link: link
    });
};

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Contact/ContactItem.tsx









var ContactItem_obj;
var TITLE = (ContactItem_obj = {}, (0,_define_property/* default */.Z)(ContactItem_obj, graphql/* ContactType.Email */.uCS.Email, "Email"), (0,_define_property/* default */.Z)(ContactItem_obj, graphql/* ContactType.Linkedin */.uCS.Linkedin, "LinkedIn"), (0,_define_property/* default */.Z)(ContactItem_obj, graphql/* ContactType.Twitter */.uCS.Twitter, "Twitter"), (0,_define_property/* default */.Z)(ContactItem_obj, graphql/* ContactType.Github */.uCS.Github, "Github"), ContactItem_obj);
var ContactItem_obj1;
var NO_DATA = (ContactItem_obj1 = {}, (0,_define_property/* default */.Z)(ContactItem_obj1, graphql/* ContactType.Email */.uCS.Email, "Link your Email"), (0,_define_property/* default */.Z)(ContactItem_obj1, graphql/* ContactType.Linkedin */.uCS.Linkedin, "Link your LinkedIn account"), (0,_define_property/* default */.Z)(ContactItem_obj1, graphql/* ContactType.Twitter */.uCS.Twitter, "Link your Twitter account"), (0,_define_property/* default */.Z)(ContactItem_obj1, graphql/* ContactType.Github */.uCS.Github, "Link your Github account"), ContactItem_obj1);
var _obj2;
var ITEMKEY = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, graphql/* ContactType.Email */.uCS.Email, "hideEmail"), (0,_define_property/* default */.Z)(_obj2, graphql/* ContactType.Linkedin */.uCS.Linkedin, "hideLinkedin"), (0,_define_property/* default */.Z)(_obj2, graphql/* ContactType.Twitter */.uCS.Twitter, "hideTwitter"), (0,_define_property/* default */.Z)(_obj2, graphql/* ContactType.Github */.uCS.Github, "hideGithub"), _obj2);
function ContactItem(props) {
    var contactType = props.contactType, name = props.name, hidden = props.hidden, isEditing = props.isEditing, isCreate = props.isCreate, updateItem = props.updateItem, blockVisibility = props.blockVisibility;
    var info = useSocialMediaInfo({
        name: name,
        contactType: contactType,
        hidden: false
    });
    var ref = (0,react.useState)(false), isLoading = ref[0], toggleIsLoading = ref[1];
    var handleChangeVisibility = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        toggleIsLoading(true);
                        _ctx.next = 3;
                        return updateItem((0,_define_property/* default */.Z)({}, ITEMKEY[contactType], value));
                    case 3:
                        toggleIsLoading(false);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleChangeVisibility(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderAction = function() {
        if (!name) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Button */.zxk, {
            onClick: info.link,
            size: "tiny",
            color: "primary",
            variant: "contained",
            children: "Link"
        });
        if (isCreate) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
            alignItems: "center",
            gap: 0.5,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                    color: "text.250",
                    variant: "body2",
                    children: "Private"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                    name: "icon-eye-off-line"
                })
            ]
        });
        if (isLoading) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* CircularProgress */.D8x, {
                size: 24
            });
        }
        if (hidden || blockVisibility === graphql/* BlockVisibility.BlockVisibilityPrivate */.T7W.BlockVisibilityPrivate) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                alignItems: "center",
                gap: 0.5,
                onClick: function() {
                    return handleChangeVisibility(false);
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        color: "text.250",
                        variant: "body2",
                        children: "Private"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                        name: "icon-eye-off-line"
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                alignItems: "center",
                gap: 0.5,
                onClick: function() {
                    return handleChangeVisibility(true);
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        color: "text.250",
                        variant: "body2",
                        children: "Public"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                        name: "icon-eye-line"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
        alignItems: "center",
        justifyContent: "space-between",
        py: 2,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
                gap: 0.5,
                onClick: function() {
                    return info.url && window.open(info.url);
                },
                sx: {
                    opacity: hidden && info.name ? 0.2 : 1,
                    transition: "opacity 0.1s"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        variant: "body1",
                        children: TITLE[contactType]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        variant: "body2",
                        color: "text.250",
                        children: info.handle || info.name || NO_DATA[contactType]
                    })
                ]
            }),
            isEditing ? renderAction() : info.url ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
                name: "icon-arrow-tiny-right"
            }) : null
        ]
    });
}
/* harmony default export */ var Contact_ContactItem = (ContactItem);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/Contact/index.tsx
















var PrivateMask = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
        gap: 1.5,
        alignItems: "center",
        justifyContent: "center",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        position: "absolute",
        bgcolor: "red",
        sx: function(param) {
            var palette = param.palette;
            return {
                bgcolor: palette.mode === "light" ? "rgba(255,255,255,0.5)" : "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(5px)"
            };
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
                name: "icon-eye-off-line"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                textAlign: "center",
                width: 200,
                variant: "body2",
                children: "Keep my contact information hidden from the public"
            })
        ]
    });
};
var Contact_EditButton = function(props) {
    var data = props.data, isCreate = props.isCreate, onPublic = props.onPublic, onPrivate = props.onPrivate;
    var ref = (0,react.useState)(false), isLoading = ref[0], toggleIsLoading = ref[1];
    var handlePrivate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        toggleIsLoading(true);
                        _ctx.next = 3;
                        return onPrivate();
                    case 3:
                        toggleIsLoading(false);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePrivate() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCreate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        toggleIsLoading(true);
                        _ctx.next = 5;
                        return onPublic();
                    case 5:
                        toggleIsLoading(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCreate() {
            return _ref.apply(this, arguments);
        };
    }();
    if (isCreate || (data === null || data === void 0 ? void 0 : data.visibility) === graphql/* BlockVisibility.BlockVisibilityPrivate */.T7W.BlockVisibilityPrivate) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* LoadingButton */.flC, {
            loading: isLoading,
            variant: "outlined",
            sx: {
                px: 1,
                height: 28,
                fontSize: 12
            },
            startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
                name: "icon-eye-off-line",
                size: 18,
                mt: -0.5
            }),
            onClick: handleCreate,
            children: "Private"
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* LoadingButton */.flC, {
        loading: isLoading,
        variant: "outlined",
        sx: {
            px: 1,
            height: 28,
            fontSize: 12
        },
        startIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
            name: "icon-eye-line",
            size: 18,
            mt: -0.5
        }),
        onClick: handlePrivate,
        children: "Public"
    });
};
function Contact(props) {
    var data = props.data, isCreate = props.isCreate, profileId = props.profileId;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks_profile/* useCreateBlocks */.ad)(), 1), createBlock = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks_profile/* useUpdateBlocks */.GP)(), 1), updateBlock = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useUpdateBlockVisibility/* useUpdateBlockVisibility */.I)(), 1), updateVisibility = ref2[0];
    var query = (0,next_router.useRouter)().query;
    var handle = ((query === null || query === void 0 ? void 0 : query.handle) || "").toString();
    var shouldCollapsed = isCreate || (data === null || data === void 0 ? void 0 : data.visibility) === graphql/* BlockVisibility.BlockVisibilityPrivate */.T7W.BlockVisibilityPrivate;
    var ref3 = (0,graphql/* useMeQuery */.UEB)(undefined, {
        skip: !couldEdit,
        selectFromResult: function selectFromResult(param) {
            var currentData = param.currentData;
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
            var privateInfo = (ref = currentData === null || currentData === void 0 ? void 0 : currentData.me.data) === null || ref === void 0 ? void 0 : ref.privateInfo;
            var ref9, ref10, ref11, ref12;
            return {
                privateContacts: couldEdit ? [
                    {
                        contactType: graphql/* ContactType.Email */.uCS.Email,
                        name: (privateInfo === null || privateInfo === void 0 ? void 0 : privateInfo.email) || "",
                        hidden: (ref9 = (ref2 = data === null || data === void 0 ? void 0 : (ref1 = data.contacts) === null || ref1 === void 0 ? void 0 : ref1.find(function(c) {
                            return c.contactType === graphql/* ContactType.Email */.uCS.Email;
                        })) === null || ref2 === void 0 ? void 0 : ref2.hidden) !== null && ref9 !== void 0 ? ref9 : true
                    },
                    {
                        contactType: graphql/* ContactType.Linkedin */.uCS.Linkedin,
                        name: (privateInfo === null || privateInfo === void 0 ? void 0 : privateInfo.linkedinId) || "",
                        hidden: (ref10 = (ref4 = data === null || data === void 0 ? void 0 : (ref3 = data.contacts) === null || ref3 === void 0 ? void 0 : ref3.find(function(c) {
                            return c.contactType === graphql/* ContactType.Linkedin */.uCS.Linkedin;
                        })) === null || ref4 === void 0 ? void 0 : ref4.hidden) !== null && ref10 !== void 0 ? ref10 : true
                    },
                    {
                        contactType: graphql/* ContactType.Twitter */.uCS.Twitter,
                        name: (privateInfo === null || privateInfo === void 0 ? void 0 : privateInfo.twitterId) || "",
                        hidden: (ref11 = (ref6 = data === null || data === void 0 ? void 0 : (ref5 = data.contacts) === null || ref5 === void 0 ? void 0 : ref5.find(function(c) {
                            return c.contactType === graphql/* ContactType.Twitter */.uCS.Twitter;
                        })) === null || ref6 === void 0 ? void 0 : ref6.hidden) !== null && ref11 !== void 0 ? ref11 : true
                    },
                    {
                        contactType: graphql/* ContactType.Github */.uCS.Github,
                        name: (privateInfo === null || privateInfo === void 0 ? void 0 : privateInfo.githubId) || "",
                        hidden: (ref12 = (ref8 = data === null || data === void 0 ? void 0 : (ref7 = data.contacts) === null || ref7 === void 0 ? void 0 : ref7.find(function(c) {
                            return c.contactType === graphql/* ContactType.Github */.uCS.Github;
                        })) === null || ref8 === void 0 ? void 0 : ref8.hidden) !== null && ref12 !== void 0 ? ref12 : true
                    }, 
                ] : undefined
            };
        }
    }), privateContacts = ref3.privateContacts, refetch = ref3.refetch;
    var contacts = privateContacts || (data === null || data === void 0 ? void 0 : data.contacts);
    var updateItemVisibility = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
            var currentState;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!((data === null || data === void 0 ? void 0 : data.visibility) === graphql/* BlockVisibility.BlockVisibilityPrivate */.T7W.BlockVisibilityPrivate)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            isSuccess: true
                        });
                    case 2:
                        currentState = (contacts || []).reduce(function(result, item) {
                            if (item.contactType === graphql/* ContactType.Email */.uCS.Email) {
                                result.hideEmail = !!item.hidden;
                            }
                            if (item.contactType === graphql/* ContactType.Github */.uCS.Github) {
                                result.hideGithub = !!item.hidden;
                            }
                            if (item.contactType === graphql/* ContactType.Linkedin */.uCS.Linkedin) {
                                result.hideLinkedin = !!item.hidden;
                            }
                            if (item.contactType === graphql/* ContactType.Twitter */.uCS.Twitter) {
                                result.hideTwitter = !!item.hidden;
                            }
                            return result;
                        }, {
                            enable: true,
                            hideEmail: true,
                            hideGithub: true,
                            hideLinkedin: true,
                            hideTwitter: true
                        });
                        return _ctx.abrupt("return", updateBlock({
                            handle: handle,
                            id: (data === null || data === void 0 ? void 0 : data.id) || "",
                            input: {
                                index: (data === null || data === void 0 ? void 0 : data.index) || 0,
                                displayName: (data === null || data === void 0 ? void 0 : data.displayName) || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Contact */.kHU.Contact],
                                contact: (0,_object_spread/* default */.Z)({}, currentState, params)
                            }
                        }));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateItemVisibility(params) {
            return _ref.apply(this, arguments);
        };
    }();
    var publicContact = function() {
        return isCreate ? createBlock({
            profileId: profileId,
            handle: handle,
            input: {
                displayName: profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Contact */.kHU.Contact],
                contact: {
                    enable: true,
                    hideGithub: false,
                    hideTwitter: false,
                    hideEmail: false,
                    hideLinkedin: false
                }
            }
        }) : updateVisibility({
            handle: handle,
            id: (data === null || data === void 0 ? void 0 : data.id) || "",
            visibility: graphql/* BlockVisibility.BlockVisibilityPublic */.T7W.BlockVisibilityPublic
        });
    };
    var privateContact = function() {
        return updateVisibility({
            handle: handle,
            id: (data === null || data === void 0 ? void 0 : data.id) || "",
            visibility: graphql/* BlockVisibility.BlockVisibilityPrivate */.T7W.BlockVisibilityPrivate
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core_BlockWrapper, {
        title: (data === null || data === void 0 ? void 0 : data.displayName) || profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Contact */.kHU.Contact],
        editButton: couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Contact_EditButton, {
            onPrivate: privateContact,
            onPublic: publicContact,
            data: data,
            isCreate: isCreate
        }) : null,
        contentProps: {
            position: "relative"
        },
        children: [
            contacts === null || contacts === void 0 ? void 0 : contacts.map(function(contact) {
                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Contact_ContactItem, (0,_object_spread/* default */.Z)({
                    blockVisibility: data === null || data === void 0 ? void 0 : data.visibility,
                    isCreate: !!isCreate,
                    updateItem: updateItemVisibility,
                    isEditing: !!couldEdit
                }, contact), contact.contactType);
            }),
            shouldCollapsed ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrivateMask, {}) : null
        ]
    }, data === null || data === void 0 ? void 0 : data.id);
}
/* harmony default export */ var blocks_Contact = (Contact);

// EXTERNAL MODULE: ./src/components/Profile/blocks/Recommendation/RecommendationList.tsx + 1 modules
var RecommendationList = __webpack_require__(60327);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Recommendation/index.tsx















var RecommendationEditor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 11).then(__webpack_require__.bind(__webpack_require__, 50011));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50011)
            ];
        }
    },
    ssr: false
});
var RecommendationListEditor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9255).then(__webpack_require__.bind(__webpack_require__, 79255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79255)
            ];
        }
    },
    ssr: false
});
function Recommendation(props) {
    var data = props.data, profileId = props.profileId, isCreate = props.isCreate;
    var eoa = (0,hooks/* useAddresses */.Jz)().eoa;
    var ref = (0,hooks_profile/* useCouldEditProfile */.sc)(), couldEdit = ref.couldEdit, isPreview = ref.isPreview;
    var ref1 = (0,react.useState)("1"), currentTab = ref1[0], setCurrentTab = ref1[1];
    var ref2 = (0,react.useState)(false), isModalOpen = ref2[0], toggleIsModal = ref2[1];
    var ref3 = (0,react.useState)(false), isListModalOpen = ref3[0], toggleIsListModal = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useLazyConnectStatusQuery */.gK0)(), 2), queryConnectStatus = ref4[0], ref5 = ref4[1], isChecking = ref5.isFetching;
    var openModal = function() {
        return toggleIsModal(true);
    };
    var closeModal = function() {
        return toggleIsModal(false);
    };
    var openListModal = function() {
        return toggleIsListModal(true);
    };
    var closeListModal = function() {
        return toggleIsListModal(false);
    };
    var handleGiveRecommendation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var connected;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return queryConnectStatus((0,utils/* getProfileQueryParams */.Vy)(profileId)).then(function(res) {
                            var ref, ref1;
                            return ((ref1 = (ref = res.data) === null || ref === void 0 ? void 0 : ref.profile.data) === null || ref1 === void 0 ? void 0 : ref1.connectStatus) === graphql/* ConnectStatus.Connected */.BMk.Connected;
                        });
                    case 2:
                        connected = _ctx.sent;
                        if (connected) {
                            _ctx.next = 6;
                            break;
                        }
                        cyberlab_uikit_src/* toast.error */.Amu.error("You need to establish a connection with this person before writing a recommendation!");
                        return _ctx.abrupt("return");
                    case 6:
                        openModal();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleGiveRecommendation() {
            return _ref.apply(this, arguments);
        };
    }();
    var recommendationData = currentTab === "2" ? data === null || data === void 0 ? void 0 : data.given : data === null || data === void 0 ? void 0 : data.received;
    var ref6;
    var myRecommendationIndex = (ref6 = recommendationData === null || recommendationData === void 0 ? void 0 : recommendationData.findIndex(function(rec) {
        var ref = (0,_sliced_to_array/* default */.Z)(rec.user.lightInfo.formattedAddress.split("..."), 2), start = ref[0], end = ref[1];
        return eoa.startsWith(start) && eoa.endsWith(end);
    })) !== null && ref6 !== void 0 ? ref6 : -1;
    var hasGivenRecommendation = myRecommendationIndex > -1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core_BlockWrapper, {
        title: profile/* DEFAULT_BLOCK_TITLE */.Oj[graphql/* BlockType.Recommendation */.kHU.Recommendation],
        contentProps: {
            gap: 4
        },
        subtitle: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Tabs */.mQc, {
            sx: {
                mt: -3,
                padding: "8px 16px 0 16px"
            },
            value: currentTab,
            onChange: function(_, v) {
                return setCurrentTab(v);
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Tab */.OK9, {
                    label: "Received",
                    value: "1"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Tab */.OK9, {
                    label: "Given",
                    value: "2"
                })
            ]
        }),
        editButton: isPreview ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* Icon */.J, {
            name: couldEdit ? "icon-edit-line" : "icon-arrow-tiny-right",
            size: 24,
            onClick: openListModal
        }),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendationList/* default */.Z, {
                data: recommendationData
            }),
            couldEdit || currentTab === "2" || hasGivenRecommendation ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* LoadingButton */.flC, {
                    loading: isChecking,
                    disabled: isPreview,
                    variant: "outlined",
                    color: "primary",
                    onClick: handleGiveRecommendation,
                    children: "Give your recommendation"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendationListEditor, {
                onGiveRecommendation: !couldEdit && !hasGivenRecommendation ? handleGiveRecommendation : undefined,
                open: isListModalOpen,
                onClose: closeListModal,
                profileId: profileId,
                blockData: data,
                couldEdit: couldEdit,
                myCommentIndex: myRecommendationIndex,
                isCreate: !!isCreate
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendationEditor, {
                open: isModalOpen,
                onClose: closeModal,
                profileId: profileId,
                blockData: data
            })
        ]
    });
}
/* harmony default export */ var blocks_Recommendation = (Recommendation);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/AddBlocks.tsx























var ORG_BLOCK_MAP = new Map([
    [
        graphql/* BlockType.Event */.kHU.Event,
        blocks_Link3Event
    ],
    [
        graphql/* BlockType.Posts */.kHU.Posts,
        blocks_Link3Post
    ],
    [
        graphql/* BlockType.Link */.kHU.Link,
        blocks_Links
    ],
    [
        graphql/* BlockType.Superlink */.kHU.Superlink,
        blocks_FeaturedContents
    ],
    [
        graphql/* BlockType.NftCollection */.kHU.NftCollection,
        blocks_OpenSea
    ],
    [
        graphql/* BlockType.Snapshot */.kHU.Snapshot,
        blocks_Snapshot
    ],
    [
        graphql/* BlockType.Twitter */.kHU.Twitter,
        blocks_Twitter
    ], 
]);
var PERSONAL_BLOCK_MAP = new Map([
    [
        graphql/* BlockType.WorkExperience */.kHU.WorkExperience,
        Work
    ],
    [
        graphql/* BlockType.Education */.kHU.Education,
        blocks_Education
    ],
    [
        graphql/* BlockType.Skill */.kHU.Skill,
        blocks_Skills
    ],
    [
        graphql/* BlockType.Link */.kHU.Link,
        blocks_Links
    ],
    [
        graphql/* BlockType.Superlink */.kHU.Superlink,
        blocks_FeaturedContents
    ],
    [
        graphql/* BlockType.Recommendation */.kHU.Recommendation,
        blocks_Recommendation
    ],
    [
        graphql/* BlockType.Contact */.kHU.Contact,
        blocks_Contact
    ],
    [
        graphql/* BlockType.NftGallery */.kHU.NftGallery,
        NFTs
    ],
    [
        graphql/* BlockType.W3StGallery */.kHU.W3StGallery,
        blocks_W3st
    ],
    [
        graphql/* BlockType.Credential */.kHU.Credential,
        blocks_Credential
    ],
    [
        graphql/* BlockType.Twitter */.kHU.Twitter,
        blocks_Twitter
    ], 
]);
// the block could be added more than once
var MULI_BLOCKS = [
    graphql/* BlockType.Twitter */.kHU.Twitter
];
var getTitle = function(type) {
    return profile/* DEFAULT_BLOCK_TITLE */.Oj[type];
};
var counldAddBlock = function(type, currentBlocks) {
    return currentBlocks.includes(type) && !MULI_BLOCKS.includes(type);
};
var renderAddBlocks = function(props) {
    var couldEdit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var blocks = props.blocks, profileType = props.profileType, restProps = (0,src_object_without_properties/* default */.Z)(props, [
        "blocks",
        "profileType"
    ]);
    var currentBlocks = blocks.map(function(b) {
        return b.type;
    });
    var BLOCK_MAP = profileType !== graphql/* ProfileType.Organization */.pqZ.Organization ? PERSONAL_BLOCK_MAP : ORG_BLOCK_MAP;
    var children = [];
    if (!couldEdit) {
        if (profileType === graphql/* ProfileType.Organization */.pqZ.Organization) {
            return null;
        } else if (profileType === graphql/* ProfileType.Personal */.pqZ.Personal && !blocks.find(function(b) {
            return b.type === graphql/* BlockType.Recommendation */.kHU.Recommendation;
        })) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(blocks_Recommendation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
                data: {
                    displayName: getTitle(graphql/* BlockType.Recommendation */.kHU.Recommendation)
                },
                isCreate: true
            }));
        } else {
            return null;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = BLOCK_MAP.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var blockType = _step.value;
            var Comp = BLOCK_MAP.get(blockType);
            if (!Comp || counldAddBlock(blockType, currentBlocks)) continue;
            children.push(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Comp, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
                data: {
                    displayName: getTitle(blockType)
                },
                isCreate: true
            })));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return children;
};
function AddBlocks(props) {
    var couldEdit = (0,hooks_profile/* useCouldEditProfile */.sc)().couldEdit;
    var children = (0,react.useMemo)(function() {
        return renderAddBlocks(props, couldEdit);
    }, [
        props.blocks,
        couldEdit
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: children
    });
}
/* harmony default export */ var blocks_AddBlocks = (AddBlocks);

// EXTERNAL MODULE: ./src/components/GlobalAvatar/index.tsx
var GlobalAvatar = __webpack_require__(64064);
// EXTERNAL MODULE: ./src/hooks/profile/useEas.ts
var useEas = __webpack_require__(61307);
// EXTERNAL MODULE: ./src/components/Profile/EAS/EASVerificationModal.tsx + 3 modules
var EASVerificationModal = __webpack_require__(21291);
// EXTERNAL MODULE: ../../packages/cyberlab-uikit/src/Modal.tsx + 4 modules
var Modal = __webpack_require__(49661);
;// CONCATENATED MODULE: ./src/components/Profile/EAS/EasClaimModal.tsx









function EasClaimModal(props) {
    var onClaim = props.onClaim, modalProps = (0,src_object_without_properties/* default */.Z)(props, [
        "onClaim"
    ]);
    var ref = (0,react.useState)(false), isLoading = ref[0], toggleIsLoading = ref[1];
    var handleClaim = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        toggleIsLoading(true);
                        _ctx.next = 3;
                        return onClaim();
                    case 3:
                        toggleIsLoading(false);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClaim() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 360,
        noCloseBtn: true
    }, modalProps), {
        PaperProps: {
            sx: {
                p: 0
            }
        },
        titleProps: {
            children: "Claim Verified Badge",
            variant: "body1",
            fontWeight: 700,
            textAlign: "center",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Stack */.Kqy, {
                mt: 2,
                textAlign: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                    variant: "body2",
                    color: "text.250",
                    children: "You just got verified as a builder in crypto! Claim your verified badge now."
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                gap: 1.5,
                mt: 4,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Button */.zxk, {
                        disabled: isLoading,
                        onClick: props.onClose,
                        fullWidth: true,
                        variant: "outlined",
                        color: "primary",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* LoadingButton */.flC, {
                        loading: isLoading,
                        onClick: handleClaim,
                        fullWidth: true,
                        variant: "contained",
                        color: "primary",
                        children: "Claim"
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var EAS_EasClaimModal = (EasClaimModal);

;// CONCATENATED MODULE: ./src/components/Profile/EAS/index.tsx











function EASVerification(props) {
    var profileId = props.profileId, type = props.type, orgName = props.orgName;
    var ref = (0,useEas/* default */.Z)(profileId), isVerified = ref.isVerified, couldClaim = ref.couldClaim, claimEAS = ref.claimEAS, attestation = ref.attestation, isClaiming = ref.isClaiming;
    var ref1 = (0,useModalState/* default */.Z)(), closeModal = ref1.closeModal, isOpen = ref1.isOpen, openModal = ref1.openModal;
    var ref2 = (0,useModalState/* default */.Z)(), closeClaimModal = ref2.closeModal, openClaimModal = ref2.openModal, isCliamModalOpen = ref2.isOpen;
    var couldEdit = (0,hooks_profile/* useCouldEditProfile */.sc)().couldEdit;
    var handleCliam = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isSuccess;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return claimEAS();
                    case 2:
                        isSuccess = _ctx.sent.isSuccess;
                        if (isSuccess) {
                            closeClaimModal();
                            openModal();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCliam() {
            return _ref.apply(this, arguments);
        };
    }();
    var getIconSize = function() {
        if (type === "member") return 18;
        return 24;
    };
    var getVerifiedIcon = function() {
        if (type === "member") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
            name: "icon-Verified-person-fill",
            size: getIconSize(),
            color: "brand.main"
        });
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrgIcon/* default */.Z, {});
    };
    if (!isVerified && !couldClaim) {
        return null;
    }
    var handleIconClick = function() {
        if (!isVerified) return;
        if (attestation.id) openModal();
        if ((couldClaim || isClaiming) && type === "member") openClaimModal();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Flex */.kCb, {
                alignItems: "center",
                onClick: handleIconClick,
                children: !couldClaim && !isClaiming ? getVerifiedIcon() : couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pwa_icons/* default */.Z, {
                    name: "icon-unclaim",
                    onClick: openClaimModal,
                    size: getIconSize(),
                    color: "text.250"
                }) : null
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EASVerificationModal/* default */.Z, {
                orgName: orgName,
                type: type,
                attestation: attestation,
                open: isOpen,
                onClose: closeModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EAS_EasClaimModal, {
                open: isCliamModalOpen,
                onClose: closeClaimModal,
                onClaim: handleCliam
            })
        ]
    });
}
/* harmony default export */ var EAS = (EASVerification);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/core/ProfileBackground.tsx



var NFTWallITem = (0,cyberlab_uikit_src/* styled */.zop)("div")(function(param) {
    var src = param.src, theme = param.theme;
    return {
        width: "100%",
        height: "100%",
        background: "url(".concat(src, ") no-repeat 100%"),
        backgroundSize: "cover",
        backgroundPosition: "center"
    };
});
function ProfileBackground(props) {
    var type = props.type, src = props.src, nfts = props.nfts;
    var renderBackground = function() {
        if (type === graphql/* PersonalPicture_Type.Nft */.peR.Nft) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Flex */.kCb, {
                height: "100%",
                justifyContent: "center",
                children: nfts === null || nfts === void 0 ? void 0 : nfts.map(function(nft) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NFTWallITem, {
                        src: nft.imageUrl,
                        sx: {
                            width: "30rem"
                        }
                    }, "".concat(nft.contract, "-").concat(nft.tokenId));
                })
            });
        }
        if (!!src) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Box */.xuv, {
                component: "img",
                position: "absolute",
                width: "100%",
                height: "100%",
                left: 0,
                top: 0,
                src: props.src,
                sx: {
                    objectFit: "cover"
                }
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* RatioBox */.Zeg, {
        ratio: 145 / 390,
        children: [
            renderBackground(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Box */.xuv, {
                width: "100%",
                height: "100%",
                bgcolor: "#000",
                position: "absolute",
                sx: {
                    opacity: 0.5
                }
            })
        ]
    });
}
/* harmony default export */ var core_ProfileBackground = (ProfileBackground);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/BasicInfo/SupportChains.tsx






function SupportChains(props) {
    var data = props.data;
    var cmcTokenId = data === null || data === void 0 ? void 0 : data.cmcTokenId;
    var networks = data === null || data === void 0 ? void 0 : data.networks;
    var _ref = (0,api/* useGetTokenPreviewQuery */.q4)(cmcTokenId, {
        skip: !cmcTokenId || cmcTokenId === "0",
        selectFromResult: function selectFromResult(_param) {
            var currentData = _param.currentData, rest = (0,src_object_without_properties/* default */.Z)(_param, [
                "currentData"
            ]);
            return {
                token: currentData === null || currentData === void 0 ? void 0 : currentData.data
            };
        }
    }), token = _ref.token;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper/* default */.Z, {
        gap: 36 / 8,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        variant: "body1",
                        color: "text.250",
                        children: "Supported Chains"
                    }),
                    networks ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* AvatarGroup */.HEJ, {
                        avatars: networks.filter(function(n) {
                            return !!n;
                        }).map(function(network) {
                            var ref;
                            return (ref = profile/* chainData */.c6[network]) === null || ref === void 0 ? void 0 : ref.icon;
                        }),
                        limit: 8
                    }) : "-"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                        variant: "body1",
                        color: "text.250",
                        children: "Token"
                    }),
                    (token === null || token === void 0 ? void 0 : token.symbol) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                        gap: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Avatar */.qEK, {
                                src: token.logo,
                                sx: {
                                    width: 20,
                                    height: 20
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                variant: "body1",
                                color: "text.100",
                                children: token.symbol || cmcTokenId
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Divider */.izJ, {
                                flexItem: true,
                                orientation: "vertical"
                            }),
                            token.price ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Text */.xvT, {
                                variant: "body1",
                                color: "brand.main",
                                children: [
                                    "~$",
                                    token.price.toFixed(2)
                                ]
                            }) : null
                        ]
                    }) : "-"
                ]
            })
        ]
    });
}
/* harmony default export */ var BasicInfo_SupportChains = (SupportChains);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/BasicInfo/OrgBasicInfo.tsx










var EditOrgBasicInfo = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8362).then(__webpack_require__.bind(__webpack_require__, 78362));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78362)
            ];
        }
    },
    ssr: false
});
function OrgBasicInfo(props) {
    var ref;
    var data = props.data;
    var couldEdit = (0,useCouldEditProfile/* useCouldEditProfile */.s)().couldEdit;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Box */.xuv, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_ProfileBackground, {
                        src: data === null || data === void 0 ? void 0 : data.backgroundPicture
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper/* default */.Z, {
                        gap: 3,
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalAvatar/* default */.Z, {
                                bordered: true,
                                sx: {
                                    mt: -8
                                },
                                size: 83,
                                src: data === null || data === void 0 ? void 0 : data.profilePicture,
                                borderWidth: 3
                            }),
                            (data === null || data === void 0 ? void 0 : data.sector) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Tag */.Vp9, {
                                containerProps: {
                                    position: "absolute",
                                    top: 24,
                                    right: 24
                                },
                                children: [
                                    "#",
                                    data.sector
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                                        gap: 0.5,
                                        mt: -1,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                                variant: "h1",
                                                color: "text.100",
                                                bold: true,
                                                children: data === null || data === void 0 ? void 0 : data.displayName
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EAS, {
                                                orgName: (data === null || data === void 0 ? void 0 : data.displayName) || "",
                                                type: "org",
                                                profileId: data === null || data === void 0 ? void 0 : data.id
                                            })
                                        ]
                                    }),
                                    couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditOrgBasicInfo, {
                                        data: data
                                    }) : null
                                ]
                            }),
                            (data === null || data === void 0 ? void 0 : data.bio) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                variant: "body2",
                                color: "text.250",
                                children: data.bio
                            }) : null,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Flex */.kCb, {
                                gap: 1.5,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Text */.xvT, {
                                    variant: "body2",
                                    color: "text.100",
                                    children: [
                                        (data === null || data === void 0 ? void 0 : (ref = data.organization) === null || ref === void 0 ? void 0 : ref.followersCount) || 0,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                            variant: "body2",
                                            display: "inline",
                                            color: "text.250",
                                            ml: 0.5,
                                            children: "Followers"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicInfo_SupportChains, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
}
/* harmony default export */ var BasicInfo_OrgBasicInfo = (OrgBasicInfo);

// EXTERNAL MODULE: ./src/components/Headline.tsx + 1 modules
var Headline = __webpack_require__(88099);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(42921);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(33927);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/Connections.tsx



function Connections(props) {
    var _connections = props.connections, connections = _connections === void 0 ? [] : _connections, total = props.total;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper/* default */.Z, {
        py: 1.5,
        gap: 1.5,
        alignItems: "center",
        justifyContent: "start",
        flexDirection: "row",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* AvatarGroup */.HEJ, {
                avatars: connections.map(function(c) {
                    return c.profilePicture.picture || "";
                }),
                limit: 5
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Text */.xvT, {
                variant: "caption",
                color: "text.100",
                textAlign: "left",
                children: [
                    connections.slice(0, 5).map(function(c) {
                        return c.displayName.displayName;
                    }).join(", "),
                    total > 5 ? " and ".concat(total - 5, " others are mutual connections") : " ".concat(total < 2 ? "is" : "are", " mutual connection").concat(total < 2 ? "" : "s")
                ]
            })
        ]
    });
}
/* harmony default export */ var blocks_Connections = (Connections);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/BasicInfo/PersonalBasicInfo.tsx














var EditPersonalBasicInfo = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6853).then(__webpack_require__.bind(__webpack_require__, 76853));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76853)
            ];
        }
    },
    ssr: false
});
var formatHeadline = function(data) {
    if (!data) return data;
    var profileId = data.profileId, result = _object_without_properties(data, [
        "profileId"
    ]);
    return result;
};
function PersonalBasicInfo(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var data = props.data;
    var ref8 = (0,useCouldEditProfile/* useCouldEditProfile */.s)(), couldEdit = ref8.couldEdit, isPreview = ref8.isPreview;
    var ref9 = (0,useEas/* default */.Z)(data === null || data === void 0 ? void 0 : data.id), isVerified = ref9.isVerified, couldClaim = ref9.couldClaim;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_ProfileBackground, {
                        type: data === null || data === void 0 ? void 0 : (ref = data.personalBackgroundPicture) === null || ref === void 0 ? void 0 : ref.type,
                        src: (0,utils/* fixNFTIPFSURL */.Ff)((data === null || data === void 0 ? void 0 : (ref1 = data.personalBackgroundPicture) === null || ref1 === void 0 ? void 0 : ref1.picture) || ""),
                        nfts: data === null || data === void 0 ? void 0 : (ref2 = data.personalBackgroundPicture) === null || ref2 === void 0 ? void 0 : ref2.nfts
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper/* default */.Z, {
                        gap: 3,
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalAvatar/* default */.Z, {
                                bordered: true,
                                sx: {
                                    mt: -8
                                },
                                size: 83,
                                src: data === null || data === void 0 ? void 0 : (ref3 = data.personalProfilePicture) === null || ref3 === void 0 ? void 0 : ref3.picture,
                                borderWidth: 3
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                                gap: 1,
                                mt: -1,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                                variant: "h1",
                                                color: "text.100",
                                                bold: true,
                                                children: data === null || data === void 0 ? void 0 : (ref4 = data.personalDisplayName) === null || ref4 === void 0 ? void 0 : ref4.displayName
                                            }),
                                            couldEdit ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditPersonalBasicInfo, {
                                                data: data
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Headline/* default */.Z, {
                                        data: data === null || data === void 0 ? void 0 : data.headline,
                                        isVerified: isVerified,
                                        couldClaim: couldClaim,
                                        profileId: data === null || data === void 0 ? void 0 : data.id,
                                        showVerify: couldEdit,
                                        verifyIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EAS, {
                                            type: "member",
                                            orgName: (data === null || data === void 0 ? void 0 : (ref5 = data.headline) === null || ref5 === void 0 ? void 0 : ref5.displayName) || (data === null || data === void 0 ? void 0 : (ref6 = data.headline) === null || ref6 === void 0 ? void 0 : ref6.twitterHandle) || "",
                                            profileId: (data === null || data === void 0 ? void 0 : data.id) || ""
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Text */.xvT, {
                                variant: "body2",
                                color: "text.250",
                                children: data === null || data === void 0 ? void 0 : data.bio
                            }),
                            (data === null || data === void 0 ? void 0 : data.mutualConnectionCount) && !couldEdit && !isPreview ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Text */.xvT, {
                                variant: "body2",
                                color: "text.100",
                                children: [
                                    data === null || data === void 0 ? void 0 : data.mutualConnectionCount,
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Text */.xvT, {
                                        variant: "body2",
                                        display: "inline",
                                        color: "text.250",
                                        ml: 0.5,
                                        children: [
                                            "Connection",
                                            data.mutualConnectionCount > 1 ? "s" : ""
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            (data === null || data === void 0 ? void 0 : data.mutualConnectionCount) && !couldEdit && !isPreview ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(blocks_Connections, {
                connections: data === null || data === void 0 ? void 0 : (ref7 = data.mutualConnections) === null || ref7 === void 0 ? void 0 : ref7.list,
                total: data.mutualConnectionCount
            }) : null
        ]
    });
}
/* harmony default export */ var BasicInfo_PersonalBasicInfo = (PersonalBasicInfo);

;// CONCATENATED MODULE: ./src/components/Profile/blocks/ProfileCompleteness.tsx





function ProfileCompleteness(props) {
    var blocks = props.blocks;
    var couldEdit = (0,hooks_profile/* useCouldEditProfile */.sc)().couldEdit;
    var percentage = (0,react.useMemo)(function() {
        return Math.min(blocks.filter(function(b) {
            return !b.isPlaceHolder;
        }).length, 10) * 10;
    }, [
        blocks
    ]);
    var getColor = function() {
        if (percentage <= 30) {
            return "error.main";
        } else if (percentage <= 60) {
            return "warning.main";
        } else {
            return "success.main";
        }
    };
    if (!couldEdit) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        title: "Profile Completeness",
        contentProps: {
            gap: 3,
            sx: {
                p: 0
            },
            alignItems: "end"
        },
        noDivider: true,
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Progress */.Exd, {
            color: getColor(),
            percentage: percentage,
            width: 100
        })
    }, "profile-completeness");
}
/* harmony default export */ var blocks_ProfileCompleteness = (ProfileCompleteness);

// EXTERNAL MODULE: ./src/components/Icons/CopyIcon.tsx
var CopyIcon = __webpack_require__(98944);
;// CONCATENATED MODULE: ./src/components/Profile/blocks/ProfileLink.tsx







function ProfileLink(param) {
    var handle = param.handle;
    var couldEdit = (0,hooks_profile/* useCouldEditProfile */.sc)().couldEdit;
    if (!couldEdit) return null;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_BlockWrapper, {
        title: "Profile Link",
        contentProps: {
            gap: 3,
            sx: {
                p: 2
            }
        },
        editButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cyberlab_uikit_src/* Button */.zxk, {
            variant: "outlined",
            size: "tiny",
            onClick: function() {
                router.push("/custom-link");
            },
            children: "Customize link"
        }),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Flex */.kCb, {
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Text */.xvT, {
                    children: [
                        "link3.to",
                        (0,utils/* getProfileRouter */.z)(handle)
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyIcon/* default */.Z, {
                    text: "link3.to".concat((0,utils/* getProfileRouter */.z)(handle))
                })
            ]
        })
    }, "profile-link");
}
/* harmony default export */ var blocks_ProfileLink = (ProfileLink);

// EXTERNAL MODULE: ./src/components/Profile/types.ts
var types = __webpack_require__(46517);
// EXTERNAL MODULE: ./src/views/Profile/ProfileConfig.context.tsx
var ProfileConfig_context = __webpack_require__(6990);
;// CONCATENATED MODULE: ./src/views/Profile/index.tsx

































var FooterAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5082).then(__webpack_require__.bind(__webpack_require__, 55082));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55082)
            ];
        }
    },
    ssr: false
});
var ADMIN_ROLE = [
    graphql/* Role.Admin */.uUj.Admin,
    graphql/* Role.Owner */.uUj.Owner
];
// @ts-ignore
var BLOCK_MAP = new Map([
    [
        graphql/* BlockType.Link */.kHU.Link,
        blocks_Links
    ],
    [
        graphql/* BlockType.NftGallery */.kHU.NftGallery,
        NFTs
    ],
    [
        graphql/* BlockType.Superlink */.kHU.Superlink,
        blocks_FeaturedContents
    ],
    [
        graphql/* BlockType.W3StGallery */.kHU.W3StGallery,
        blocks_W3st
    ],
    [
        graphql/* BlockType.Twitter */.kHU.Twitter,
        blocks_Twitter
    ],
    [
        graphql/* BlockType.Credential */.kHU.Credential,
        blocks_Credential
    ],
    [
        graphql/* BlockType.NftCollection */.kHU.NftCollection,
        blocks_OpenSea
    ],
    [
        graphql/* BlockType.Snapshot */.kHU.Snapshot,
        blocks_Snapshot
    ],
    [
        graphql/* BlockType.Event */.kHU.Event,
        blocks_Link3Event
    ],
    [
        graphql/* BlockType.Posts */.kHU.Posts,
        blocks_Link3Post
    ],
    [
        graphql/* BlockType.Skill */.kHU.Skill,
        blocks_Skills
    ],
    [
        graphql/* BlockType.Recommendation */.kHU.Recommendation,
        blocks_Recommendation
    ],
    [
        graphql/* BlockType.WorkExperience */.kHU.WorkExperience,
        Work
    ],
    [
        graphql/* BlockType.Education */.kHU.Education,
        blocks_Education
    ],
    [
        graphql/* BlockType.Contact */.kHU.Contact,
        blocks_Contact
    ], 
]);
var Blocks = function(props) {
    var _blocks = props.blocks, blocks = _blocks === void 0 ? [] : _blocks, profileId = props.profileId;
    var couldEdit = (0,hooks_profile/* useCouldEditProfile */.sc)().couldEdit;
    var renderBlock = function(block) {
        var Comp = BLOCK_MAP.get(block.type);
        if (Comp !== undefined) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Comp, {
                data: block,
                profileId: profileId
            }, block.id);
        }
        return null;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: blocks.map(function(block) {
            return renderBlock(block);
        })
    });
};
function Profile(props) {
    var isPreview = props.isPreview;
    var ref = (0,next_router.useRouter)(), _query = ref.query, handleFromQuery = _query.handle, back = ref.back;
    var ref1 = (0,utils/* getProfileQueryParams */.Vy)(handleFromQuery), handle = ref1.handle, id = ref1.id;
    var couldEdit = (0,hooks_profile/* useCouldEditProfile */.sc)().couldEdit;
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var ref2 = (0,graphql/* useGetProfileQuery */.MxC)({
        handle: handle,
        id: id
    }, {
        skip: !id && !handle,
        selectFromResult: function selectFromResult(param) {
            var currentData = param.currentData, isLoading = param.isLoading;
            return {
                profile: currentData === null || currentData === void 0 ? void 0 : currentData.profile.data,
                isLoading: isLoading
            };
        },
        refetchOnMountOrArgChange: true
    }), profile = ref2.profile, isLoading = ref2.isLoading;
    // const { profileMetaData } = useGetProfileMetadataQuery(
    //   { handle, id },
    //   {
    //     skip: !id && !handle,
    //     selectFromResult({ currentData, isLoading }) {
    //       return {
    //         profileMetaData: currentData?.profile.data as any,
    //         isLoading,
    //       };
    //     },
    //   },
    // );
    (0,react.useEffect)(function() {
        if ((0,types/* isPersonalProfile */.y)(profile) && profile.id) {
            dispatch(graphql/* api.endpoints.getProfileIdentities.initiate */.hi0.endpoints.getProfileIdentities.initiate((0,utils/* getProfileQueryParams */.Vy)(profile.id)));
        }
    }, [
        profile === null || profile === void 0 ? void 0 : profile.id
    ]);
    var renderFooter = function() {
        if (isPreview) return null;
        if ((0,types/* isPersonalProfile */.y)(profile) && !couldEdit) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterAction, {
                userId: profile.owner.id,
                profileId: profile.id,
                connectStatus: profile.connectStatus
            });
        }
        if ((0,types/* isOrgProfile */.$)(profile) && profile.organization.verification === graphql/* VerificationStatus.Verified */.$ZB.Verified && !couldEdit) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterAction, {
                connectStatus: graphql/* ConnectStatus.Unconnected */.BMk.Unconnected,
                userId: "",
                profileId: profile.id,
                type: profile.type,
                isFollowing: profile.isFollowing
            });
        }
        if ((0,types/* isOrgProfile */.$)(profile) && ADMIN_ROLE.includes(profile.organization.currentAccess)) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterAction, {
                orgId: profile.organization.id,
                profileId: profile.id,
                type: "ADMIN",
                isFollowing: profile.isFollowing
            });
        }
        return null;
    };
    var footer = renderFooter();
    if (isLoading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Profile_skeleton, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileConfig_context/* default */.Z, {
        isPreview: isPreview,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(cyberlab_uikit_src/* Stack */.Kqy, {
            gap: 1,
            pb: !!footer ? 12.25 : 1,
            position: "relative",
            bgcolor: "bg.default",
            children: [
                isPreview ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Profile_Header, {
                    handle: profile === null || profile === void 0 ? void 0 : profile.handle
                }),
                (0,types/* isPersonalProfile */.y)(profile) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicInfo_PersonalBasicInfo, {
                    data: profile
                }) : null,
                (0,types/* isOrgProfile */.$)(profile) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicInfo_OrgBasicInfo, {
                    data: profile
                }) : null,
                (0,types/* isPersonalProfile */.y)(profile) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(blocks_ProfileLink, {
                    handle: profile === null || profile === void 0 ? void 0 : profile.handle
                }) : null,
                (0,types/* isPersonalProfile */.y)(profile) && (profile === null || profile === void 0 ? void 0 : profile.blocks) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(blocks_ProfileCompleteness, {
                    blocks: profile.blocks
                }) : null,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Blocks, {
                    blocks: profile === null || profile === void 0 ? void 0 : profile.blocks.filter(function(block) {
                        return couldEdit || block.visibility !== graphql/* BlockVisibility.BlockVisibilityPrivate */.T7W.BlockVisibilityPrivate && !block.isPlaceHolder;
                    }),
                    profileId: (profile === null || profile === void 0 ? void 0 : profile.id) || ""
                }),
                (profile === null || profile === void 0 ? void 0 : profile.blocks) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(blocks_AddBlocks, {
                    profileType: profile.type,
                    profileId: (profile === null || profile === void 0 ? void 0 : profile.id) || "",
                    blocks: profile.blocks
                }) : null,
                footer
            ]
        })
    });
}
/* harmony default export */ var views_Profile = (Profile);


/***/ }),

/***/ 68558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FX": function() { return /* binding */ useLazyQuerySpacesQuery; },
/* harmony export */   "rp": function() { return /* binding */ useGetProposalsInSpaceQuery; }
/* harmony export */ });
/* unused harmony exports OrderDirection, GetProposalsInSpaceDocument, GetSpaceByIdDocument, QuerySpacesDocument, api, useLazyGetProposalsInSpaceQuery, useGetSpaceByIdQuery, useLazyGetSpaceByIdQuery, useQuerySpacesQuery */
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87533);

var OrderDirection;
(function(OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection || (OrderDirection = {}));
var GetProposalsInSpaceDocument = "\n    query getProposalsInSpace($first: Int = 3, $spaceId: String) {\n  proposals(first: $first, where: {space: $spaceId}) {\n    id\n    title\n    body\n    start\n    end\n    state\n  }\n}\n    ";
var GetSpaceByIdDocument = "\n    query getSpaceById($id: String) {\n  space(id: $id) {\n    id\n    avatar\n    followersCount\n    name\n  }\n}\n    ";
var QuerySpacesDocument = "\n    query querySpaces($search: String!) {\n  ranking(first: 10, where: {search: $search}) {\n    items {\n      id\n      name\n      followers: followersCount\n      avatar\n    }\n  }\n}\n    ";
var injectedRtkApi = _client__WEBPACK_IMPORTED_MODULE_0__/* .api.injectEndpoints */ .h.injectEndpoints({
    endpoints: function(build) {
        return {
            getProposalsInSpace: build.query({
                query: function(variables) {
                    return {
                        document: GetProposalsInSpaceDocument,
                        variables: variables
                    };
                }
            }),
            getSpaceById: build.query({
                query: function(variables) {
                    return {
                        document: GetSpaceByIdDocument,
                        variables: variables
                    };
                }
            }),
            querySpaces: build.query({
                query: function(variables) {
                    return {
                        document: QuerySpacesDocument,
                        variables: variables
                    };
                }
            })
        };
    }
});

var useGetProposalsInSpaceQuery = injectedRtkApi.useGetProposalsInSpaceQuery, useLazyGetProposalsInSpaceQuery = injectedRtkApi.useLazyGetProposalsInSpaceQuery, useGetSpaceByIdQuery = injectedRtkApi.useGetSpaceByIdQuery, useLazyGetSpaceByIdQuery = injectedRtkApi.useLazyGetSpaceByIdQuery, useQuerySpacesQuery = injectedRtkApi.useQuerySpacesQuery, useLazyQuerySpacesQuery = injectedRtkApi.useLazyQuerySpacesQuery;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5351,7536,1922,1187,8225,9774,2888,179], function() { return __webpack_exec__(13124); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);